<template>
  <div id="RequestVamNew">
    <loading v-if="LOADING"></loading>
    <panel
      class="no-print"
      :Title="$GetIsAnbohSaz() == 'false' ? 'درخواست وام' : 'درخواست واحد'"
      :Des="
        $GetIsAnbohSaz() == 'false'
          ? 'از طریق این فرم می‌توانید درخواست وام خود را ثبت نمایید'
          : 'از طریق این فرم می‌توانید درخواست واحد خود را ثبت نمایید'
      "
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card class="no-print">
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-hand-holding-usd"></i>
          {{ $GetIsAnbohSaz() == "false" ? "درخواست وام" : "درخواست واحد" }}
        </h6>
      </template>
      <template slot="content">
        <div class="netpa-list-page-header">
        <nav class="vam-stepper" dir="rtl" aria-label="مراحل ثبت درخواست">
          <ol class="vam-stepper__list">
            <li
              v-for="(step, index) in vamSteps"
              :key="step.id"
              class="vam-stepper__item"
              :class="{
                'vam-stepper__item--active': divToShow === step.id,
                'vam-stepper__item--completed': isStepCompleted(step.id),
                'vam-stepper__item--locked': !canNavigateToStep(step.id),
                'vam-stepper__item--last': index === vamSteps.length - 1,
              }"
            >
              <button
                type="button"
                class="vam-stepper__btn"
                :disabled="!canNavigateToStep(step.id)"
                :title="getStepTabTitle(step.id)"
                :aria-current="divToShow === step.id ? 'step' : null"
                @click="goToStep(step.id)"
              >
                <span class="vam-stepper__circle">
                  <i
                    v-if="isStepCompleted(step.id) && divToShow !== step.id"
                    class="fas fa-check"
                    aria-hidden="true"
                  ></i>
                  <span v-else>{{ step.id }}</span>
                </span>
                <span class="vam-stepper__label">{{ step.label }}</span>
              </button>
            </li>
          </ol>
        </nav>
        </div>

        <div class="request-vam-content text-right py-3 px-0">
        <div
          v-if="divToShow == 1"
          class="request-vam-step-panel request-vam-step"
        >
          <div
            class="request-vam-type-list"
            dir="rtl"
            role="radiogroup"
            :aria-label="
              $GetIsAnbohSaz() == 'false' ? 'نوع وام' : 'نوع واحد'
            "
          >
            <button
              v-for="(item, key) in Vamha"
              :key="key"
              type="button"
              role="radio"
              :aria-checked="SelectedVam.id == item.id ? 'true' : 'false'"
              class="request-vam-type-card"
              :class="{
                'request-vam-type-card--selected': SelectedVam.id == item.id,
              }"
              @click="SelectedVam.id != item.id && seLectVam(item)"
            >
              <span class="request-vam-type-card__radio" aria-hidden="true">
                <i class="fas fa-check"></i>
              </span>
              <span class="request-vam-type-card__info">
                <span class="request-vam-type-card__title">{{
                  item.desNoe
                }}</span>
                <span v-if="item.des" class="request-vam-type-card__desc">
                  {{ item.des }}
                </span>
              </span>
            </button>
          </div>
          <div class="request-vam-step-nav request-vam-step-nav--next-only request-vam-step-nav--narrow">
            <button
              type="button"
              :disabled="Object.entries(SelectedVam).length === 0"
              @click="nextPage(2)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
            >
              مرحله بعد
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div
          v-if="divToShow == 2"
          class="request-vam-step-panel request-vam-step"
        >
          <section class="vam-section">
            <div class="row request-vam-form-grid mx-0">
            <div class="col-12 col-md-6 py-2 vam-f-amount">
              <label for="MabVam" class="text-secondary">{{
                $GetIsAnbohSaz() == "false" ? " مبلغ وام" : "مبلغ واحد"
              }}</label>
              <input
                :disabled="
                  ((SelectedVam.bnpCashDBtblNoeId == 66 ||
                    SelectedVam.bnpCashDBtblNoeId == 65) &&
                    $session.get('CustCode') == '843') ||
                  FixInputMabVam == true
                "
                type="text"
                id="MabVam"
                class="form-control text-left 3ragham"
                v-model="vamDetail.MablaghVam"
                @keypress="$ValidNumber($event, 15, false)"
                @keyup="
                  vamDetail.MablaghVam = $Comma3ragham(vamDetail.MablaghVam)
                "
                @blur="
                  $PutCommatoInput();
                  handleMablagh($event);
                  calculateMablaghghest();
                  UpdateZamenPolicy();
                "
                dir="ltr"
              />
            </div>
            <div class="col-12 col-md-6 py-2 request-vam-date-field vam-f-date">
              <label for="NeedData" class="text-secondary d-block"
                >تاریخ درخواست</label
              >
              <date-picker
                disabled
                v-model="vamDetail.NeedData"
                color="#f38905"
              ></date-picker>
              <input
                type="text"
                id="NeedData"
                v-model="vamDetail.NeedData"
                class="d-none InputText"
                dir="ltr"
              />
            </div>
            <div class="col-12 col-md-6 py-2 vam-f-count">
              <label for="ghestNum" class="text-secondary"> تعداد قسط</label>
              <input
                type="number"
                id="ghestNum"
                v-model="vamDetail.TedadGhest"
                class="form-control text-left"
                @blur="
                  handleTedad($event);
                  calculateMablaghghest();
                  UpdateZamenPolicy();
                "
                maxlength="3"
                @keypress="$ValidNumber($event, 12, false)"
                dir="ltr"
              />
            </div>
            <div class="col-12 col-md-6 py-2 vam-f-installment">
              <label for="ghestmab" class="text-secondary"> مبلغ قسط </label>
              <!-- <small v-if="$session.get('CustCode') == '932'" class="text-dark mx-2">( مبلغ زیر بدون محاسبه کارمزد می باشد )</small> -->
              <input
                disabled="disabled"
                type="text"
                id="ghestmab"
                v-model="vamDetail.Mablaghghest"
                class="form-control text-left 3ragham"
              />
            </div>
            <div
              class="col-12 col-md-6 py-2 vam-f-extra"
              v-if="$session.get('CustCode') == 793"
            >
              <label class="text-secondary"> موارد مصرفی وام</label>
              <select class="form-control" v-model="tblMavaredMasrafiVamId">
                <option :value="0">
                  -- یکی از موارد مصرف را انتخاب کنید --
                </option>
                <option
                  v-for="(item, key) in ListMavaredMasrafVam"
                  :key="key"
                  :value="item.id"
                >
                  {{ item.onvanMavaredMasrafVam }}
                </option>
              </select>
            </div>
            <div
              v-if="
                $session.get('CustCode') == '932' &&
                SelectedVam.bnpCashDBtblNoeId == 2698162
              "
              class="col-12 col-md-6 py-2 vam-f-extra"
            >
              <label class="text-secondary"> مدت سپرده ( ماه ) </label>
              <input
                class="form-control text-center required"
                type="number"
                maxlength="3"
                v-model="vamDetail.SepordeTime"
              />
            </div>
            <div class="col-12 col-md-6 py-2 vam-f-pay">
              <label class="text-secondary">
                {{
                  $GetIsAnbohSaz() == "false"
                    ? "نحوه پرداخت وام"
                    : "نحوه دریافت واحد"
                }}</label
              >
              <select v-model="nahvepardakht" class="form-control Pointer">
                <option value="4014" v-if="$session.get('CustCode') != '793'">
                  واریز به حساب بانکی
                </option>
                <option
                  selected
                  value="4015"
                  v-if="
                    $session.get('CustCode') != '932' &&
                    $session.get('CustCode') != '843' &&
                    $session.get('CustCode') != '259'
                  "
                >
                  واریز به حساب پس انداز
                </option>
              </select>
            </div>
            <div class="col-12 col-md-6 py-2 vam-f-account">
              <span
                v-if="
                  nahvepardakht == 4015 && $session.get('CustCode') != '932'
                "
              >
                <label class="text-secondary">انتخاب حساب پس انداز </label>
                <select class="form-control Pointer" v-model="NahveVarizDetail">
                  <option
                    v-for="item in ListTaahodat"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.desNoe }}
                  </option>
                </select>
              </span>
              <span
                v-if="
                  nahvepardakht == 4014 && $session.get('CustCode') != '793'
                "
              >
                <label class="text-secondary">انتخاب حساب بانکی </label>
                <select class="form-control Pointer" v-model="NahveVarizDetail">
                  <option
                    v-for="item in ListAzaHesab"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.bankName }} -- {{ item.hesabNo }}
                  </option>
                </select>

                <button
                  v-if="ListAzaHesab.length == 0"
                  class="mt-1 btn btn-primary float-left"
                  @click="createAccount()"
                >
                  افزودن شماره حساب
                </button>
              </span>
            </div>
            </div>
          </section>
          <div
            v-if="showStep2InfoCards"
            class="request-vam-info-cards"
            :class="{
              'request-vam-info-cards--solo': step2InfoCardCount === 1,
            }"
          >
            <div v-if="showStep2LimitCard" class="request-vam-info-card vam-info">
              <div class="vam-info__header">
                <i class="fas fa-sliders-h" aria-hidden="true"></i>
                <span>شرایط و محدودیت‌ها</span>
              </div>
              <ul class="vam-info__rows">
                <li v-if="SelectedVam.minMablagh > 0" class="vam-info__row">
                  <span class="vam-info__label">حداقل مبلغ قابل درخواست</span>
                  <span class="vam-info__value">
                    {{ this.$Comma3ragham(SelectedVam.minMablagh) }}
                    <small>{{ $GetVahedPool() }}</small>
                  </span>
                </li>
                <li v-if="SelectedVam.maxMablagh > 0" class="vam-info__row">
                  <span class="vam-info__label">حداکثر مبلغ قابل درخواست</span>
                  <span class="vam-info__value">
                    {{
                      $session.get("CustCode") == "932"
                        ? this.$Comma3ragham(Math.round(SelectedVam.maxMablagh))
                        : this.$Comma3ragham(SelectedVam.maxMablagh)
                    }}
                    <small>{{ $GetVahedPool() }}</small>
                  </span>
                </li>
                <li v-if="SelectedVam.minTedad > 0" class="vam-info__row">
                  <span class="vam-info__label">حداقل تعداد قسط درخواستی</span>
                  <span class="vam-info__value">
                    {{ this.$Comma3ragham(SelectedVam.minTedad) }}
                  </span>
                </li>
                <li v-if="SelectedVam.maxTedad > 0" class="vam-info__row">
                  <span class="vam-info__label">حداکثر تعداد قسط درخواستی</span>
                  <span class="vam-info__value">
                    {{ this.$Comma3ragham(SelectedVam.maxTedad) }}
                  </span>
                </li>
              </ul>
            </div>
            <div
              v-if="showStep2NotesCard"
              class="request-vam-info-card vam-info vam-info--notes"
            >
              <div class="vam-info__header">
                <i class="fas fa-info-circle" aria-hidden="true"></i>
                <span>توضیحات و نکات</span>
              </div>
              <div v-if="lines" class="request-vam-info-card__block">
                <p class="vam-info__text" v-for="line in lines" :key="line">
                  {{ line }}
                </p>
              </div>
              <div
                v-if="SelectedVam.isUpload && linesattachment"
                class="request-vam-info-card__block"
              >
                <div class="request-vam-info-card__subtitle">
                  شرایط آپلود مدارک
                  {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }}
                </div>
                <ul class="vam-info__list">
                  <li v-for="line in linesattachment" :key="line">
                    {{ line }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="request-vam-step-nav request-vam-step-nav--narrow">
            <button
              type="button"
              @click="nextPage(1)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
            >
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
              مرحله قبل
            </button>
            <button
              type="button"
              :disabled="!(isValidTedad == true && isValidMablaghVam == true)"
              @click="nextPage(3)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
            >
              مرحله بعد
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div
          v-if="divToShow == 3"
          class="request-vam-step-panel request-vam-step"
        >
          <div class="vam-section">
            <div
              v-if="!ListNoePolicyFilter || guarantorCount === 0"
              class="vam-notice"
            >
              <i class="fas fa-info-circle" aria-hidden="true"></i>
              <span>
                {{
                  "این نوع وام نیازی به ضامن ندارد ، بر روی دکمه مرحله بعدی کلیک کنید"
                }}
              </span>
            </div>
            <div v-else class="request-vam-zamen-grid">
              <div
                v-for="index in guarantorIndices"
                :key="index"
                class="request-vam-zamen-slot"
                :class="{
                  'request-vam-zamen-slot--solo': isGuarantorSoloRow(index),
                }"
              >
                <label :for="'zamenCode' + index">{{
                  guarantorPlaceholder(index)
                }}</label>
                <div class="request-vam-zamen-input-group">
                  <input
                    :id="'zamenCode' + index"
                    type="text"
                    inputmode="numeric"
                    maxlength="10"
                    class="form-control request-vam-zamen-code"
                    v-model="ListCodeMeli[index]"
                    placeholder="کد ملی ۱۰ رقمی"
                    dir="ltr"
                  />
                  <button
                    type="button"
                    class="request-vam-zamen-check-btn"
                    @click="GetZament(index)"
                  >
                    استعلام
                  </button>
                </div>
                <div
                  v-if="
                    $session.get('CustCode') == 932 &&
                    SelectedVam.id != '11292371'
                  "
                  class="request-vam-zamen-ramz"
                >
                  <label :for="'zamenRamz' + index">
                    رمز کسر اقساط ضامن {{ index + 1 }}
                  </label>
                  <input
                    :id="'zamenRamz' + index"
                    type="number"
                    class="form-control text-center"
                    v-model="ListRamzKasrAghsat[index]"
                  />
                  <small class="vam-hint">
                    رمز کسر اقساط شامل 13 رقم میباشد که توسط سازمان تامین اجتماعی
                    پیامک میگردد
                  </small>
                </div>
                <div
                  v-if="getGuarantorResult(index)"
                  class="request-vam-zamen-result"
                >
                  <i class="fas fa-user-check" aria-hidden="true"></i>
                  <span class="request-vam-zamen-result__label">نام ضامن:</span>
                  <span class="request-vam-zamen-result__name">{{
                    getGuarantorResult(index).NameFamily
                  }}</span>
                  <button
                    type="button"
                    class="request-vam-zamen-result__remove"
                    title="حذف ضامن"
                    aria-label="حذف ضامن"
                    @click="OnDelete(getGuarantorResult(index).CodeMeli)"
                  >
                    <i class="fa fa-trash-alt" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button
            class="d-none"
            id="ZamenModal"
            data-toggle="modal"
            data-target="#Modal-Orange"
          >
            modal
          </button>
          <div class="request-vam-step-nav request-vam-step-nav--narrow">
            <button
              type="button"
              @click="nextPage(2)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
            >
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
              مرحله قبل
            </button>
            <button
              type="button"
              :disabled="
                vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0
              "
              @click="nextPage(4)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
            >
              مرحله بعد
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div
          v-if="divToShow == 4"
          class="request-vam-step-panel request-vam-step"
        >
          <div class="vam-section request-vam-upload-section">
            <div
              v-if="SelectedVam.isUpload && $cookies.isKey('DownloadForm')"
              class="vam-notice vam-notice--warning"
            >
              <i class="fas fa-file-download" aria-hidden="true"></i>
              <span>
                برای دانلود فرم درخواست وام
                <a
                  class="vam-notice__link"
                  :href="$cookies.get('DownloadForm')"
                  download="فرم درخواست وام"
                  >اینجا</a
                >
                کلیک کنید.
              </span>
            </div>

            <div v-if="SelectedVam.isUpload" class="request-vam-upload-card">
              <input
                v-if="
                  $session.get('CustCode') == '932' ||
                  $session.get('CustCode') == '8002'
                "
                type="file"
                id="attachmentUploader"
                multiple="multiple"
                @change="changeattach($event)"
                class="d-none"
                accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
              />
              <input
                v-else
                type="file"
                id="attachmentUploader"
                @change="changeattach($event)"
                class="d-none"
                accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
              />
              <div class="request-vam-upload-card__icon" aria-hidden="true">
                <i class="fas fa-cloud-upload-alt"></i>
              </div>
              <p class="request-vam-upload-card__title">
                بارگذاری مدارک
                {{
                  $GetIsAnbohSaz() == "false" ? "درخواست وام" : "درخواست واحد"
                }}
              </p>
              <p class="request-vam-upload-card__hint">
                فرمت‌های مجاز: gif, jpg, png, zip, rar, pdf
              </p>
              <div v-if="attachment" class="request-vam-upload-card__meta">
                <i class="far fa-file-alt" aria-hidden="true"></i>
                <span class="request-vam-upload-card__file">{{
                  uploadImageName || attachment.name
                }}</span>
                <span class="request-vam-upload-card__size" dir="ltr">
                  {{
                    imageSize || Math.round((attachment.size || 0) / 1000)
                  }}
                  KB
                </span>
              </div>
              <button
                type="button"
                class="request-vam-upload-card__btn"
                @click="clickUploader"
              >
                {{ attachment ? "تغییر فایل" : "انتخاب فایل" }}
              </button>
            </div>

            <div
              v-if="
                $session.get('CustCode') == '932' &&
                SelectedVam.id != '11292371'
              "
              class="request-vam-upload-kasr"
            >
              <label for="codeKasrAghsat">
                کد کسر اقساط خود را وارد نمایید
              </label>
              <input
                id="codeKasrAghsat"
                type="number"
                class="form-control text-center"
                v-model="codeKasrAghsat"
              />
              <small class="vam-hint">
                رمز کسر اقساط شامل 13 رقم میباشد که توسط سازمان تامین اجتماعی
                پیامک میگردد
              </small>
            </div>

            <div
              v-if="SelectedVam.isUpload"
              class="request-vam-info-card vam-info vam-info--notes"
            >
              <div class="vam-info__header">
                <i class="fas fa-info-circle" aria-hidden="true"></i>
                <span>
                  شرایط آپلود مدارک
                  {{ $GetIsAnbohSaz() == "false" ? "تسهیلات" : "قرارداد" }}
                </span>
              </div>
              <ul class="vam-info__list">
                <li v-for="line in linesattachment" :key="line">
                  {{ line }}
                </li>
              </ul>
            </div>
            <div v-else class="vam-notice">
              <i class="fas fa-info-circle" aria-hidden="true"></i>
              <span>
                {{
                  $GetIsAnbohSaz() == "false"
                    ? "مدارکی برای این نوع تسهیلات برای آپلود نیاز نیست"
                    : "مدارکی برای این نوع قرارداد برای آپلود نیاز نیست"
                }}
              </span>
            </div>
          </div>
          <div class="request-vam-step-nav request-vam-step-nav--narrow">
            <button
              type="button"
              @click="nextPage(3)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
            >
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
              مرحله قبل
            </button>
            <button
              v-if="SelectedVam.isUpload && attachment != null"
              type="button"
              @click="nextPage(5)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
            >
              مرحله بعد
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
            <button
              v-else-if="!SelectedVam.isUpload"
              type="button"
              @click="nextPage(5)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
            >
              مرحله بعد
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
            <button
              v-else
              type="button"
              disabled
              class="request-vam-step-nav__btn request-vam-step-nav__btn--next"
            >
              مرحله بعد
              <i class="fa fa-arrow-left" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        <div
          v-if="divToShow == 5"
          class="request-vam-step-panel request-vam-step"
        >
          <div class="vam-section request-vam-review">
            <p class="request-vam-review-intro">
              اطلاعات زیر را بررسی کنید؛ در صورت نیاز با دکمه «ویرایش» به مرحله
              مربوطه برگردید.
            </p>

            <section class="request-vam-review-hero">
              <div class="request-vam-review-hero__top">
                <span class="request-vam-review-hero__name">
                  <i class="fas fa-hand-holding-usd" aria-hidden="true"></i>
                  {{ SelectedVam.desNoe }}
                </span>
                <button
                  type="button"
                  class="request-vam-review-hero__edit"
                  @click="goToStep(2)"
                >
                  <i class="fas fa-pen" aria-hidden="true"></i>
                  ویرایش
                </button>
              </div>
              <div class="request-vam-review-hero__amount">
                <span dir="ltr">{{ $Comma3ragham(vamDetail.MablaghVam) }}</span>
                <small>{{ $GetVahedPool() }}</small>
              </div>
              <span class="request-vam-review-hero__caption"
                >مبلغ درخواستی</span
              >
              <div class="request-vam-review-hero__stats">
                <div
                  v-if="this.$session.get('CustCode') != 9"
                  class="request-vam-review-hero__stat"
                >
                  <span class="request-vam-review-hero__stat-label"
                    >مبلغ هر قسط</span
                  >
                  <span class="request-vam-review-hero__stat-value" dir="ltr">
                    {{ $Comma3ragham(vamDetail.Mablaghghest) }}
                    {{ $GetVahedPool() }}
                  </span>
                </div>
                <div class="request-vam-review-hero__stat">
                  <span class="request-vam-review-hero__stat-label"
                    >تعداد قسط</span
                  >
                  <span class="request-vam-review-hero__stat-value" dir="ltr">{{
                    vamDetail.TedadGhest
                  }}</span>
                </div>
                <div class="request-vam-review-hero__stat">
                  <span class="request-vam-review-hero__stat-label"
                    >تاریخ درخواست</span
                  >
                  <span class="request-vam-review-hero__stat-value" dir="ltr">{{
                    vamDetail.NeedData
                  }}</span>
                </div>
              </div>
            </section>

            <section class="request-vam-review-panel">
              <header class="request-vam-review-panel__header">
                <span class="request-vam-review-panel__icon" aria-hidden="true">
                  <i class="fas fa-user-friends"></i>
                </span>
                <h6 class="request-vam-review-panel__title">مشخصات ضامنین</h6>
                <button
                  v-if="guarantorCount > 0"
                  type="button"
                  class="request-vam-review-panel__edit"
                  @click="goToStep(3)"
                >
                  <i class="fas fa-pen" aria-hidden="true"></i>
                  ویرایش
                </button>
              </header>
              <div
                v-if="reviewGuarantors.length === 0"
                class="request-vam-review-empty"
              >
                ضامنی ثبت نشده است.
              </div>
              <div
                v-else
                class="request-vam-review-guarantor-list"
                id="ZamenInformation"
              >
                <article
                  v-for="(item, key) in reviewGuarantors"
                  :key="item.Id || item.CodeMeli || key"
                  class="request-vam-review-guarantor-card"
                >
                  <header class="request-vam-review-guarantor-card__header">
                    <span class="request-vam-review-guarantor-card__badge">{{
                      key + 1
                    }}</span>
                    <span class="request-vam-review-guarantor-card__title">{{
                      item.NameFamily
                    }}</span>
                  </header>
                  <div class="request-vam-review-guarantor-card__grid">
                    <div class="request-vam-review-field">
                      <span class="request-vam-review-field__label">کدملی</span>
                      <span
                        class="request-vam-review-field__value request-vam-review-field__value--ltr"
                        >{{ item.CodeMeli }}</span
                      >
                    </div>
                    <div class="request-vam-review-field">
                      <span class="request-vam-review-field__label"
                        >نام پدر</span
                      >
                      <span class="request-vam-review-field__value">{{
                        item.Pedar
                      }}</span>
                    </div>
                    <div class="request-vam-review-field">
                      <span class="request-vam-review-field__label"
                        >شماره تماس</span
                      >
                      <span
                        class="request-vam-review-field__value request-vam-review-field__value--ltr"
                        >{{ item.Tel }}</span
                      >
                    </div>
                    <div class="request-vam-review-field">
                      <span class="request-vam-review-field__label"
                        >شماره همراه</span
                      >
                      <span
                        class="request-vam-review-field__value request-vam-review-field__value--ltr"
                        >{{ item.Mobile }}</span
                      >
                    </div>
                    <div
                      class="request-vam-review-field request-vam-review-field--full"
                    >
                      <span class="request-vam-review-field__label">آدرس</span>
                      <span class="request-vam-review-field__value">{{
                        item.Adres
                      }}</span>
                    </div>
                  </div>
                </article>
              </div>
            </section>

            <section class="request-vam-review-panel">
              <header class="request-vam-review-panel__header">
                <span class="request-vam-review-panel__icon" aria-hidden="true">
                  <i class="fas fa-paperclip"></i>
                </span>
                <h6 class="request-vam-review-panel__title">مشخصات فایل‌ها</h6>
                <button
                  v-if="SelectedVam.isUpload"
                  type="button"
                  class="request-vam-review-panel__edit"
                  @click="goToStep(4)"
                >
                  <i class="fas fa-pen" aria-hidden="true"></i>
                  ویرایش
                </button>
              </header>
              <div
                v-if="!attachment"
                class="request-vam-review-empty"
                :class="{ 'request-vam-review-empty--danger': SelectedVam.isUpload }"
              >
                <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
                فایلی بارگذاری نشده
              </div>
              <div v-else class="request-vam-review-file">
                <i class="far fa-file-alt" aria-hidden="true"></i>
                <span class="request-vam-review-file__name">{{
                  uploadImageName || attachment.name
                }}</span>
                <span class="request-vam-review-file__size" dir="ltr">
                  {{
                    imageSize || Math.round((attachment.size || 0) / 1000)
                  }}
                  KB
                </span>
              </div>
            </section>

            <div
              v-if="
                $session.get('CustCode') == '932' &&
                SelectedVam.bnpCashDBtblNoeId == 363490
              "
              class="vam-notice vam-notice--warning request-vam-review-terms"
            >
              <input
                id="vamTerms932"
                type="checkbox"
                v-model="CheckBedoneSeporder932"
              />
              <label for="vamTerms932">
                ثبت نام مجدد بابت تسهیلات بدون سپرده، منوط به گذشت سه ماه از
                آخرین قسط پرداخت تسهیلات قبلی می باشد، در صورت ثبت درخواست زودتر
                از موعد، مدارک مربوطه بایگانی و پس از زمان ذکرشده واریز می گردد.
              </label>
            </div>
          </div>

          <div class="request-vam-step-nav request-vam-step-nav--narrow">
            <button
              type="button"
              @click="nextPage(4)"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--prev"
            >
              <i class="fa fa-arrow-right" aria-hidden="true"></i>
              مرحله قبل
            </button>
            <button
              type="button"
              @click="Submit"
              class="request-vam-step-nav__btn request-vam-step-nav__btn--submit"
            >
              <i class="fa fa-check" aria-hidden="true"></i>
              ثبت نهایی درخواست
            </button>
          </div>
        </div>
      </div>
      </template>
    </net-pa-card>
    <button
      class="btn btn-outline-secondary btn-sm m-1 d-none"
      id="openModal"
      type="button"
      data-toggle="modal"
      data-target="#Modal-light"
    >
      <span>تغــییر وضعیت</span>
    </button>
    <ModalCustom>
      <template v-slot:ContentModalLight>
        <div class="">
          <div class="alert alert-info text-center">
            اطلاعات ضامن خود را وارد نمایید و اطلاعات خواسته شده را تکمیل
            فرمایید .
          </div>
          <div class="row" id="NewZamenForm">
            <div class="col-12 col-md-4 p-2">
              <input
                type="text"
                placeholder="نام و نام خانوادگی"
                class="form-control text-center required"
                v-model="ZamenToInsert.NameFamily"
              />
            </div>
            <div
              class="col-12 col-md-4 p-2"
              v-if="
                $session.get('CustCode') != '932' &&
                $session.get('CustCode') != '8002'
              "
            >
              <input
                type="text"
                placeholder="نام پدر"
                class="form-control required"
                v-model="ZamenToInsert.Pedar"
              />
            </div>
            <div
              class="col-12 col-md-4 p-2"
              v-if="
                $session.get('CustCode') != '932' &&
                $session.get('CustCode') != '8002'
              "
            >
              <input
                type="text"
                placeholder="شغل"
                class="form-control required"
                v-model="ZamenToInsert.Job"
              />
            </div>
            <div
              class="col-12 col-md-4 p-2"
              v-if="
                $session.get('CustCode') != '932' &&
                $session.get('CustCode') != '8002'
              "
            >
              <input
                type="number"
                placeholder="تلفن ثابت"
                class="form-control text-left required"
                v-model="ZamenToInsert.Tel"
              />
            </div>
            <div class="col-12 col-md-4 p-2">
              <input
                type="number"
                placeholder="تلفن همراه"
                class="form-control text-center required"
                v-model="ZamenToInsert.Mobile"
              />
            </div>
            <div class="col-12 col-md-4 p-2">
              <input
                type="number"
                placeholder="شماره پرسنلی | مستمری"
                class="form-control text-center required"
                v-model="ZamenToInsert.PerNo"
              />
            </div>
            <div
              class="col-12 p-2 col-md-12"
              v-if="
                $session.get('CustCode') != '932' &&
                $session.get('CustCode') != '8002'
              "
            >
              <textarea
                type="text"
                class="form-control"
                v-model="ZamenToInsert.Adres"
                placeholder="آدرس"
              >
              </textarea>
            </div>
            <div
              class="col-12 p-2 text-right"
              v-if="
                $session.get('CustCode') == '932' ||
                $session.get('CustCode') == '8002'
              "
            >
              <input
                type="file"
                @change="changefile($event)"
                class="d-none required"
                id="Uploader"
                accept=".gif,.jpg,.jpeg,.png,.pdf"
              />
              <button
                class="btn btn-primary m-2 Netpa-btn"
                @click="clickUploaderZamen"
                style="margin: auto"
              >
                بارگذاری مدارک ضامن
              </button>
              <!-- <uploader :whithName="false" :Idu="'FormFile'" :key="keyrender" :base64="null" :TableName="'wwwtblNeedVam'" @Done="GetFile" :attachId="null" :address="null" :grp="181070513" :title="'فایل خود را بارگذاری کنید'" :MasterId="$session.get('CustCode')"></uploader> -->
              <span class="text-danger" v-if="!fileinfo.name"
                >فایل مربوط به ضامن بارگذاری نشده</span
              >
              <span v-if="fileinfo.name"
                ><b>نام فایل :</b> {{ fileinfo.name }}</span
              >&nbsp;&nbsp;
              <span v-if="fileinfo.name"
                ><b> اندازه فایل : </b> KB {{ fileinfo.size / 1000 }}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <button class="btn btn-success NetPa-btn w-100" @click="NewZamen">
                ثبت ضامن
              </button>
            </div>
            <div class="col-md-4"></div>
          </div>
        </div>
      </template>
    </ModalCustom>
  </div>
</template>

<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import ModalCustom from "../Tools/ModalCustom.vue";
import uploader from "../../components/CmpNetPa/Componenets/NetpaUploader.vue";
import JSZip from "jszip";
import loading from "../Tools/NetPa/Loading.vue";
export default {
  data() {
    return {
      CheckBedoneSeporder932: false,
      LOADING: false,
      codeKasrAghsat: null,
      ListNoePolicy: null,
      ListNoePolicyFilter: null,
      lines: [],
      linesattachment: [],
      SelectedVam: {},
      // vamDetail: {
      //     id: 0,
      //     des: '',
      //     desNoe: '' ,
      //     desUpload: '',
      //     isActive: true,
      //     minMablagh: 0,
      //     maxMablagh: 0,
      //     isformula: false,
      //     minTedad: 1,
      //     maxTedad: 36,
      //     isUpload: false,
      //     isSafteElectronic: false,
      //     NeedData:''
      // },
      nahvepardakht:
        this.$session.get("CustCode") != "832" &&
        this.$session.get("CustCode") != "932"
          ? 4015
          : 4014,
      NahveVarizDetail: null,
      DataAxiosTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosAzaHesab: {
        ArryfildValue: "",
        Method: "Get",
        Action: "AzaHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      ListTaahodat: [],
      ListAzaHesab: [],
      vamDetail: {
        Mablaghghest: 0,
        TedadGhest: 24,
        MablaghVam: 0,
        NeedData: "",
        SepordeTime: null,
      },
      isValidMablaghVam: false,
      isValidTedad: false,
      divToShow: 1,
      maxReachedStep: 1,
      completedSteps: [],
      Vamha: [],
      DataAxiosGetNoeVam: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/SelTozihatRequest",
        Token: this.$session.get("TokenNetPa"),
      },
      DataActionVamCondition: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/VamCondition",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxiosZamenPolicy: {
        ArryfildValue: "",
        Method: "Post",
        Action: "RequestVamNew/GetZamenPolicyOnline",
        Token: this.$session.get("TokenNetPa"),
      },
      ListCodeMeli: [],
      ListRamzKasrAghsat: [],
      ListZamen: [],
      attachment: null,
      ZamenToInsert: {},
      ListZamenToInsert: [],
      fileinfo: {},
      uploadImageName: "",
      base64: null,
      imageSize: 0,
      fileFormat: "",
      ListMavaredMasrafVam: [],
      tblMavaredMasrafiVamId: 0,
      FixInputMabVam: false,
    };
  },
  components: { NetPaCard, Panel, ModalCustom, uploader, loading },
  computed: {
    vamSteps() {
      const isLoan = this.$GetIsAnbohSaz() == "false";
      return [
        { id: 1, label: isLoan ? "انتخاب نوع وام" : "انتخاب نوع واحد" },
        { id: 2, label: "اطلاعات تکمیلی" },
        { id: 3, label: "مشخصات ضامنین" },
        { id: 4, label: "آپلود مدارک" },
        { id: 5, label: "تایید نهایی" },
      ];
    },
    guarantorCount() {
      if (!this.ListNoePolicyFilter || this.ListNoePolicyFilter.tedad == null) {
        return 0;
      }
      return Number(this.ListNoePolicyFilter.tedad) || 0;
    },
    guarantorIndices() {
      const count = Math.max(0, this.guarantorCount);
      return Array.from({ length: count }, (_, index) => index);
    },
    showStep2LimitCard() {
      const vam = this.SelectedVam || {};
      return (
        vam.minMablagh > 0 ||
        vam.maxMablagh > 0 ||
        vam.minTedad > 0 ||
        vam.maxTedad > 0
      );
    },
    showStep2NotesCard() {
      return (
        (this.lines && this.lines.length > 0) ||
        (this.SelectedVam.isUpload &&
          this.linesattachment &&
          this.linesattachment.length > 0)
      );
    },
    step2InfoCardCount() {
      let count = 0;
      if (this.showStep2LimitCard) count += 1;
      if (this.showStep2NotesCard) count += 1;
      return count;
    },
    showStep2InfoCards() {
      return this.step2InfoCardCount > 0;
    },
    reviewGuarantors() {
      return (this.ListZamen || []).filter(
        (item) => item && (item.Id != null || item.NameFamily || item.CodeMeli),
      );
    },
  },
  mounted() {
    this.nahvepardakht =
      this.$session.get("CustCode") != "832" &&
      this.$session.get("CustCode") != "932"
        ? 4015
        : 4014;
    this.vamDetail.NeedData = this.$GetJalaliDate();
    this.GetNoeVam();
    //#region Sandogh Oliya 793
    if (
      this.$session.get("CustCode") == 793 ||
      this.$session.get("CustCode") == 8002
    ) {
      this.GetMavaredMasrafi();
    }
    //#endregion
  },
  updated() {
    console.log("*-*-*-*-*-*-*-", this.attachment);
  },
  methods: {
    createAccount() {
      this.$router.push({
        path: "UserInfo",
        query: {
          autoClick: "true",
        },
      });
    },
    getVamAmount(value) {
      if (value == null || value === "") return 0;
      return Number(String(value).replaceAll(/,/g, "").replace(/\./g, "")) || 0;
    },
    isStepCompleted(step) {
      return this.completedSteps.includes(step);
    },
    hasRequiredAttachment() {
      if (!this.SelectedVam || !this.SelectedVam.isUpload) return true;
      return !!this.attachment;
    },
    isStepUnlocked(step) {
      if (step === 1) return true;
      if (step === 2) return Object.entries(this.SelectedVam).length !== 0;
      if (step === 3) {
        return (
          this.getVamAmount(this.vamDetail.Mablaghghest) !== 0 &&
          this.getVamAmount(this.vamDetail.MablaghVam) !== 0 &&
          this.isValidTedad === true &&
          this.isValidMablaghVam === true
        );
      }
      if (step === 5) return this.hasRequiredAttachment();
      return true;
    },
    canNavigateToStep(step) {
      if (step > this.maxReachedStep) return false;
      return this.isStepUnlocked(step);
    },
    getStepTabTitle(step) {
      if (this.canNavigateToStep(step)) return "";
      if (step === 2 && Object.entries(this.SelectedVam).length === 0) {
        return "ابتدا نوع وام را مشخص کنید";
      }
      if (step === 3) {
        if (
          this.getVamAmount(this.vamDetail.Mablaghghest) === 0 ||
          this.getVamAmount(this.vamDetail.MablaghVam) === 0
        ) {
          return "لطفا اطلاعات وام را تکمیل کنید";
        }
        if (!this.isValidTedad || !this.isValidMablaghVam) {
          return "لطفا اطلاعات وام را تکمیل کنید";
        }
      }
      if (step > this.maxReachedStep) {
        return "ابتدا مراحل قبلی را تکمیل کنید";
      }
      return "";
    },
    goToStep(step) {
      if (!this.canNavigateToStep(step)) return;
      window.scrollTo({ top: 0 });
      this.divToShow = step;
    },
    prevPage(step) {
      if (step < 1 || step > 5) return;
      this.goToStep(step);
    },
    isGuarantorSoloRow(index) {
      const total = this.guarantorIndices.length;
      return total === 1 || (total % 2 === 1 && index === total - 1);
    },
    guarantorPlaceholder(index) {
      const labels = ["اول", "دوم", "سوم", "چهارم", "پنجم"];
      return `کدملی ضامن ${labels[index] || index + 1}`;
    },
    getGuarantorResult(index) {
      const code = this.ListCodeMeli[index];
      if (code) {
        const found = this.ListZamen.find((z) => z.CodeMeli == code);
        if (found && found.NameFamily) return found;
      }
      const byIndex = this.ListZamen[index];
      return byIndex && byIndex.NameFamily ? byIndex : null;
    },
    activateStep(number) {
      for (let i = 1; i < number; i++) {
        if (!this.completedSteps.includes(i)) {
          this.completedSteps.push(i);
        }
      }
      this.maxReachedStep = Math.max(this.maxReachedStep, number);
      this.divToShow = number;
      window.scrollTo({ top: 0 });
    },
    Submit() {
      if (!this.hasRequiredAttachment()) {
        this.$mySweetDefault("خطا", "بارگذاری مدارک الزامی است", "error", 2000);
        return;
      }
      if (this.$session.get("CustCode") == "932") {
        if (
          this.CheckBedoneSeporder932 == false &&
          this.SelectedVam.bnpCashDBtblNoeId == 363490
        ) {
          this.$mySweetDefault(
            "عدم پذیرفتن شرایط",
            "برای درخواست این نوع وام باید شرایط ثبت نام را بپذیرید",
            "info",
            3000,
          );
        } else {
          this.$SweetQustion(
            "تایید نهایی درخواست",
            "در صورت ثبت درخواست و بارگذاري مدارك پس از 10 روز کاری به قسمت تسهيلات-پيگيري درخواست وام ورود كرده و از وضعيت ارسال مدارك خويش مطلع شويد",
            "info",
            "تایید نهایی",
            "انصراف",
            null,
            this.FinalSubmit,
            this.cancel,
          );
        }
      } else {
        this.FinalSubmit();
      }
    },
    FinalSubmit() {
      if (!this.hasRequiredAttachment()) {
        this.LOADING = false;
        this.$mySweetDefault("خطا", "بارگذاری مدارک الزامی است", "error", 2000);
        return;
      }
      if (this.reviewGuarantors.length > 0) {
        if (!this.$ValidForm("ZamenInformation")) {
          return;
        }
      }
      this.LOADING = true;
      var formdata = new FormData();
      // console.log('😎 ~ FinalSubmit ~ this.ListZamen:', this.ListZamen)
      this.vamDetail.MablaghVam = this.vamDetail.MablaghVam.replaceAll(",", "");
      formdata.append("MablaghEftetahHesab", this.$GetMablaghEftetahHesab());
      formdata.append(
        "ramzKasrAghsat",
        this.codeKasrAghsat == null ? "" : this.codeKasrAghsat,
      );
      formdata.append("NahveVarizDetail", this.NahveVarizDetail);
      formdata.append("WwwtblcomboIdNahveVarizGrp7", this.nahvepardakht);
      formdata.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formdata.append("RequestTarix", this.$store.state.JalaliDate);
      formdata.append("Mablagh", this.vamDetail.MablaghVam);
      formdata.append("MablaghTavanaiePardakht", this.vamDetail.MablaghVam);
      formdata.append("TedadGhest", this.vamDetail.TedadGhest);
      formdata.append("NeedTarix", this.vamDetail.NeedData);
      formdata.append(
        "CodeMeliZamenAsli",
        typeof this.ListCodeMeli[0] == "undefined" ? "" : this.ListCodeMeli[0],
      );
      formdata.append(
        "CodeMeliZamenFarei",
        this.ListCodeMeli != null && this.ListCodeMeli.length > 1
          ? this.ListCodeMeli[1]
          : "",
      );
      formdata.append(
        "NameFamilyZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].NameFamily,
      );
      formdata.append(
        "CodeMeliMoaref",
        this.ListCodeMeli != null && this.ListCodeMeli.length > 2
          ? this.ListCodeMeli[2]
          : "",
      );
      formdata.append(
        "PedarZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Pedar,
      );
      formdata.append(
        "TelZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Tel,
      );
      formdata.append(
        "MobileZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Mobile,
      );
      formdata.append(
        "AdresZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Adres,
      );
      formdata.append(
        "MobileZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Mobile
          : "",
      );
      formdata.append(
        "AdresZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Adres
          : "",
      );
      formdata.append(
        "TelZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Tel
          : "",
      );
      formdata.append(
        "PedarZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Pedar
          : "",
      );
      formdata.append(
        "NameFamilyZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].NameFamily
          : "",
      );
      formdata.append(
        "ShoghlZamenAsli",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Job,
      );
      formdata.append(
        "ShoghlZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Job
          : "",
      );
      formdata.append(
        "ShoglMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Job
          : "",
      );
      formdata.append(
        "AdresMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Adres
          : "",
      );
      formdata.append(
        "MobileMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Mobile
          : "",
      );
      formdata.append(
        "TellMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Tel
          : "",
      );
      formdata.append(
        "PedarMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Pedar
          : "",
      );
      formdata.append(
        "NameFamiliMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].NameFamily
          : "",
      );
      formdata.append(
        "AzaIdMoaref",
        this.ListZamen.length != 0 && this.ListZamen.length > 2
          ? this.ListZamen[2].Id
          : "",
      );
      formdata.append(
        "AzaIdZamenFarei",
        this.ListZamen.length != 0 && this.ListZamen.length > 1
          ? this.ListZamen[1].Id
          : "",
      );
      formdata.append(
        "AzaIdZamen",
        this.ListZamen.length == 0 ? "" : this.ListZamen[0].Id,
      );
      formdata.append("IsTaeidVam", 0);
      formdata.append("SepordeTime", this.vamDetail.SepordeTime);
      formdata.append("wwwtblNoeId", this.SelectedVam.id);

      // 932
      formdata.append(
        "CodeKasreAghsatZamenAsli",
        typeof this.ListZamen[0] == "undefined"
          ? ""
          : this.ListZamen[0].RamzKasrAghsatZamen,
      );
      formdata.append(
        "CodeKasreAghsatZamenFari",
        typeof this.ListZamen[1] == "undefined"
          ? ""
          : this.ListZamen[1].RamzKasrAghsatZamen,
      );
      formdata.append(
        "CodeKasreAghsatMoaref",
        typeof this.ListZamen[2] == "undefined"
          ? ""
          : this.ListZamen[2].RamzKasrAghsatZamen,
      );

      // 793
      formdata.append("tblMavaredMasrafiVamId", this.tblMavaredMasrafiVamId);

      if (
        this.$session.get("CustCode") == 932 ||
        this.$session.get("CustCode") == 8002
      ) {
        if (this.SelectedVam.isUpload && this.base64) {
          formdata.append("Image", JSON.stringify(this.base64));
        }
      } else if (this.$session.get("CustCode") == 868) {
        if (this.FileHokm868) formdata.append("FileHokm868", this.FileHokm868);
        if (this.FileZamenanat868)
          formdata.append("FileZamenanat868", this.FileZamenanat868);
        if (this.FileGhardad868)
          formdata.append("FileGhardad868", this.FileGhardad868);
      } else if (this.attachment) {
        formdata.append("file", this.attachment);
      }
      if (this.ListZamen.length > 0) {
        if (this.ListNoePolicyFilter.isOzv == false) {
          formdata.append(
            "PerNoZamen",
            this.ListZamen[0] ? this.ListZamen[0].PerNo : null,
          );
          formdata.append(
            "PerNoZamenFarei",
            this.ListZamen[1] ? this.ListZamen[1].PerNo : null,
          );
          formdata.append(
            "PerNoMoaref",
            this.ListZamen[2] ? this.ListZamen[2].PerNo : null,
          );
        } else {
          formdata.append("PerNoZamen", null);
          formdata.append("PerNoZamenFarei", null);
          formdata.append("PerNoMoaref", null);
        }
      }

      var DataAxiosSubmit = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "InsNewVam",
        Token: this.$session.get("TokenNetPa"),
      };

      this.$PostFormData(DataAxiosSubmit)
        .then((data) => {
          if (data.success == "SUCCESS") {
            const fileErrorMsg = "درخواست وام ثبت نشد. خطا در ذخیره فایل.";
            const cancelIncomplete = (id) => {
              if (!id) return;
              var formCancel = new FormData();
              formCancel.append("needVamId", id);
              this.$PostFormData({
                ArryfildValue: formCancel,
                Method: "Post",
                Action: "InsNewVam/CancelIncompleteNeedVam",
                Token: this.$session.get("TokenNetPa"),
              }).then(() => {});
            };
            const showFileError = (needIdToCancel) => {
              if (needIdToCancel) cancelIncomplete(needIdToCancel);
              this.LOADING = false;
              this.needVamId = 0;
              this.$mySweetDefault(
                "عملیات ناموفق",
                fileErrorMsg,
                "error",
                2500,
              );
            };
            const finishSuccess = () => {
              this.ListZamenToInsert.forEach((element) => {
                if (element.file && element.file.size) {
                  let DataAxiosUpload = {
                    ArryfildValue: "",
                    Method: "Post",
                    Action: "EftetahHesab/SaveAttachmentToDb",
                    Token: "",
                  };
                  var formdataZamen = new FormData();
                  formdataZamen.append("IdEftetah", this.needVamId);
                  formdataZamen.append("Image", element.file);
                  formdataZamen.append("TableName", "wwwtblNeedVam");
                  formdataZamen.append("wwwtblcomboidgrp328", 181070523);
                  DataAxiosUpload.ArryfildValue = formdataZamen;
                  this.$PostFormData(DataAxiosUpload).then(() => {});
                }
              });
              this.LOADING = false;
              this.$mySweetDefault(
                "عملیات موفق",
                "درخواست وام شما با کد رهگیری " +
                  data.codeRahgiri +
                  " در سیستم ثبت شد.",
                "success",
                2500,
              );
              this.$router.push("loanFollowup");
            };

            if (data.fileSaved === false) {
              showFileError();
              return;
            }

            this.needVamId = data.needVamId;
            finishSuccess();
          } else {
            this.LOADING = false;
            this.needVamId = 0;
            this.$mySweetDefault(
              "عملیات ناموفق",
              data.msg
                ? data.msg
                : "درخواست شما در سیستم ثبت نشد." +
                    "لطفا در روزهای بعدی اقدام به ثبت درخواست کنید",
              "warning",
              2500,
            );
          }
        })
        .catch((error) => {
          this.LOADING = false;
          this.$mySweetDefault(
            "عملیات ناموفق",
            "مشکلی بوجود آمده است. دوباره تلاش کنید",
            "error",
            2500,
          );
          this.needVamId = 0;
          console.warn(error);
        });
    },
    OnDelete(data) {
      for (let index = 0; index < this.ListZamen.length; index++) {
        if (this.ListZamen[index].CodeMeli == data) {
          this.ListZamen.splice(index, 1);
        }
      }
    },
    GetZament(number) {
      this.fileinfo = {};
      // console.log('number',number);
      if (
        this.$session.get("UserInfoNetPa").codeMeli.trim() ==
        this.ListCodeMeli[number]
      ) {
        this.$mySweetDefault(
          "خطا",
          "شما کد ملی خود را وارد کرده اید",
          "error",
          2000,
        );
        this.ListRamzKasrAghsat[number] = "";
        return;
      }
      if (
        this.$session.get("CustCode") == 932 &&
        (this.ListRamzKasrAghsat[number] == undefined ||
          this.ListRamzKasrAghsat[number].length < 1) &&
        this.SelectedVam.id != "11292371"
      ) {
        this.$mySweetDefault(
          "خطا",
          "کد کسر اقساط ضامن را وارد نکرده اید",
          "error",
          2000,
        );
        return;
      } else if (
        this.$session.get("CustCode") == 932 &&
        (this.ListRamzKasrAghsat[number] == undefined ||
          this.ListRamzKasrAghsat[number].length != 13) &&
        this.SelectedVam.id != "11292371"
      ) {
        this.$mySweetDefault(
          "خطا",
          "کد کسر اقساط ضامن 13 رقمی می باشد",
          "error",
          2000,
        );
        return;
      }
      if (this.ListCodeMeli[number].length < 10) {
        this.$mySweetDefault(
          "خطا",
          " طول کد ملی نمیتواند کمتر از 10 رقم باشد",
          "error",
          2000,
        );
      } else {
        var DataAxiosGetZament = {
          ArryfildValue: "",
          Method: "Post",
          Action: "GetZamenByMelli3Onlione",
          Token: this.$session.get("TokenNetPa"),
        };
        var formdata = new FormData();
        formdata.append(
          "wwwtblShobeId",
          this.$session.get("UserInfoNetPa").wwwtblShobeId,
        );
        formdata.append("CodeMeli", this.ListCodeMeli[number]);
        DataAxiosGetZament.ArryfildValue = formdata;
        this.$PostFormData(DataAxiosGetZament).then((data) => {
          if (data != null) {
            if (data.success && data.success == "Failed") {
              if (this.ListNoePolicyFilter.isOzv == true) {
                //وقتی که عضویت ضامن اجباری باشد
                this.$mySweetDefault("خطا", data.message, "error", 3500);
              } else {
                this.$mySweetDefaultTost(
                  "عدم وجود عضو",
                  "کد ملی وارد شده یافت نشد لطفا اطلاعات ضامن خود را وارد نمایید",
                  "warning",
                  1500,
                );
                //باز شدن مدال و گرفتن اطلاعات ضامن
                document.getElementById("openModal").click();
                this.ZamenToInsert["CodeMeli"] = this.ListCodeMeli[number];
                if (this.$session.get("CustCode") == 932) {
                  this.ZamenToInsert["RamzKasrAghsatZamen"] =
                    this.ListRamzKasrAghsat[number];
                }
              }
              // console.log(this.ListNoePolicyFilter)
            } else if (data.mandeZemanat != null) {
              console.log("*/*//*/*", data);

              if (
                data.mandeZemanat >=
                  Number(this.vamDetail.MablaghVam.replace(/\,/g, "")) ||
                data.mandeZemanat == 0
              ) {
                //مبلغ وام کمتر از سقف ضمانت می باشد
                if (this.ListZamen.length == 0) {
                  if (this.ListNoePolicyFilter.maxCountForZemanat == -1) {
                    // تعداد ضمانت فرد ثابل قبول می باشد
                    this.ListZamen.push({
                      Tel: data.tel,
                      Pedar: data.pedar,
                      NameFamily: data.nameFamily,
                      Mobile: data.mobile,
                      Adres: data.adres,
                      Id: data.id,
                      CodeMeli: this.ListCodeMeli[number],
                      RamzKasrAghsatZamen: this.ListRamzKasrAghsat[number],
                    });
                    return;
                  } else {
                    if (
                      data.countZemanat <
                        this.ListNoePolicyFilter.maxCountForZemanat ||
                      (data.countZemanat == 0 &&
                        this.ListNoePolicyFilter.maxCountForZemanat == 0)
                    ) {
                      this.ListZamen.push({
                        Tel: data.tel,
                        Pedar: data.pedar,
                        NameFamily: data.nameFamily,
                        Mobile: data.mobile,
                        Adres: data.adres,
                        Id: data.id,
                        CodeMeli: this.ListCodeMeli[number],
                        RamzKasrAghsatZamen: this.ListRamzKasrAghsat[number],
                      });
                      return;
                    } else {
                      this.$mySweetDefaultTost(
                        "هشدار",
                        "ضامن وارد شده به سقف تعداد ضمانت رسیده ، لطفا ضامن دیگری انتحاب نمایید",
                        "warning",
                        2000,
                      );
                      this.ListRamzKasrAghsat[number] = "";
                      return;
                    }
                  }
                } else {
                  for (let index = 0; index < this.ListZamen.length; index++) {
                    if (
                      this.ListZamen[index].CodeMeli ==
                      this.ListCodeMeli[number]
                    ) {
                      this.$mySweetDefault(
                        "هشدار",
                        "ضامن تکراری است",
                        "warning",
                        2000,
                      );
                      return;
                    } else {
                      if (this.ListNoePolicyFilter.maxCountForZemanat == -1) {
                        this.ListZamen.push({
                          Tel: data.tel,
                          Pedar: data.pedar,
                          NameFamily: data.nameFamily,
                          Mobile: data.mobile,
                          Adres: data.adres,
                          Id: data.id,
                          CodeMeli: this.ListCodeMeli[number],
                          RamzKasrAghsatZamen: this.ListRamzKasrAghsat[number],
                        });
                        return;
                      } else {
                        if (
                          data.countZemanat <
                            this.ListNoePolicyFilter.maxCountForZemanat ||
                          (data.countZemanat == 0 &&
                            this.ListNoePolicyFilter.maxCountForZemanat == 0)
                        ) {
                          this.ListZamen.push({
                            Tel: data.tel,
                            Pedar: data.pedar,
                            NameFamily: data.nameFamily,
                            Mobile: data.mobile,
                            Adres: data.adres,
                            Id: data.id,
                            CodeMeli: this.ListCodeMeli[number],
                            RamzKasrAghsatZamen:
                              this.ListRamzKasrAghsat[number],
                          });
                          return;
                        } else {
                          this.$mySweetDefaultTost(
                            "هشدار",
                            "ضامن وارد شده به سقف تعداد ضمانت خود رسیده ، لطفا ضامن دیگری انتحاب نمایید",
                            "warning",
                            2000,
                          );
                          return;
                        }
                      }
                    }
                  }
                }
              } else {
                this.$mySweetDefault(
                  "خطا",
                  "ضامن وارد شده به سقف مبلغ ضمانت و یا سقف تعداد ضمانت خود رسیده ، لطفا ضامن دیگری انتخاب نمایید",
                  "error",
                  3500,
                );
              }
            } else {
              this.$mySweetDefault(
                "خطا",
                "خطایی در محاسبه مانده ضمانت ضامن رخ داده ",
                "error",
                3500,
              );
            }
          }
        });
      }
    },
    handleMablagh(event) {
      const inputValue = Number(
        event.target.value.replace(/,/g, "").replace(/\./g, ""),
      );
      if (inputValue == NaN) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار مبلغ درخواستی معتبر نمیباشد",
          "warning",
          3000,
        );
        this.isValidMablaghVam = "false";
        return false;
      }

      if (
        inputValue < Number(this.SelectedVam.minMablagh) &&
        Number(this.SelectedVam.minMablagh) > 0
      ) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار حداقل مبلغ درخواستی رعایت نشده است",
          "warning",
          3000,
        );
        this.isValidMablaghVam = false;
        return false;
      }
      let mab =
        this.$session.get("CustCode") == "932"
          ? Math.round(Number(this.SelectedVam.maxMablagh))
          : Number(this.SelectedVam.maxMablagh);
      if (inputValue > mab && Number(this.SelectedVam.maxMablagh) > 0) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار حداکثر مبلغ درخواستی رعایت نشده است",
          "warning",
          3000,
        );
        this.isValidMablaghVam = false;
        return false;
      } else this.isValidMablaghVam = true;
    },
    handleTedad(event) {
      const inputValue = Number(event.target.value);

      if (
        inputValue < Number(this.SelectedVam.minTedad) &&
        Number(this.SelectedVam.minTedad) > 0
      ) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار حداقل تعداد قسط درخواستی رعایت نشده است",
          "warning",
          3000,
        );
        this.isValidTedad = false;
        return false;
      }

      if (
        inputValue > Number(this.SelectedVam.maxTedad) &&
        Number(this.SelectedVam.maxTedad) > 0
      ) {
        this.$mySweetDefault(
          "هشدار",
          "مقدار حداکثر تعداد قسط درخواستی رعایت نشده است",
          "warning",
          3000,
        );
        this.isValidTedad = false;
        return false;
      } else this.isValidTedad = true;
    },
    calculateMablaghghest(e) {
      if (
        this.SelectedVam.isformula &&
        (this.$session.get("CustCode") == 868 ||
          this.$session.get("CustCode") == 920 ||
          this.$session.get("CustCode") == 932)
      ) {
        var formdata = new FormData();
        formdata.append("wwwtblNoeId", this.SelectedVam.id);
        formdata.append(
          "MabDarkhastVam",
          Number(this.vamDetail.MablaghVam.replace(/,/g, "")),
        );
        formdata.append("TedadGhest", this.vamDetail.TedadGhest);
        formdata.append("TarixDarkhast", this.vamDetail.NeedData);
        var DataAxios = {
          ArryfildValue: formdata,
          Method: "Post",
          Action: "InsNewVam/CalcKarmozd",
          Token: this.$session.get("TokenNetPa"),
        };
        this.$PostFormData(DataAxios).then((res) => {
          this.vamDetail.Mablaghghest =
            (res.data[0].karmozdBimeSood +
              Number(this.vamDetail.MablaghVam.replace(/,/g, ""))) /
            this.vamDetail.TedadGhest;
          this.vamDetail.Mablaghghest = Math.round(this.vamDetail.Mablaghghest);
          this.vamDetail.Mablaghghest = this.vamDetail.Mablaghghest + "";
          this.vamDetail.Mablaghghest =
            this.$session.get("CustCode") == 868
              ? this.$Comma3ragham(
                  Number(this.vamDetail.Mablaghghest.replace(/\d{4}$/, "0000")),
                )
              : this.$Comma3ragham(Number(this.vamDetail.Mablaghghest));
        });
      } else {
        if (this.SelectedVam.TedadGhest == 0) {
          this.vamDetail.Mablaghghest = 0;
        } else {
          this.vamDetail.Mablaghghest =
            Number(this.vamDetail.MablaghVam.replaceAll(/,/g, "")) > 0
              ? this.$Comma3ragham(
                  Math.round(
                    Number(this.vamDetail.MablaghVam.replaceAll(/,/g, "")) /
                      this.vamDetail.TedadGhest,
                  ),
                )
              : 0;
        }
      }
    },
    selectCurent(data, number) {
      this.activateStep(number);
    },
    nextPage(number) {
      window.scrollTo({
        top: 0,
      });
      this.calculateMablaghghest();
      if (number == 2) {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append("wwwtblSarfaslTypeId", 2);
        this.DataAxiosTaahodat.ArryfildValue = formData;
        this.$PostFormData(this.DataAxiosTaahodat).then((data) => {
          this.ListTaahodat = data;
        });

        this.DataAxiosAzaHesab.ArryfildValue = {
          Id: this.$session.get("UserInfoNetPa").wwwtblAzaId,
        };
        this.$GetData_Header(this.DataAxiosAzaHesab).then((data) => {
          this.ListAzaHesab = data;
        });
      }
      if (number == 3) {
        if (
          this.NahveVarizDetail == null &&
          this.$session.get("CustCode") == "932"
        ) {
          this.$mySweetDefault(
            "عدم انتخاب حساب بانکی",
            "لطفا حساب بانکی خودرا انتخاب کنید ",
            "warning",
            2000,
          );
          return;
        }
        if (
          this.$session.get("CustCode") == "932" &&
          this.SelectedVam.bnpCashDBtblNoeId == 2698162 &&
          (this.vamDetail.SepordeTime == 0 ||
            this.vamDetail.SepordeTime == null)
        ) {
          this.$mySweetDefault(
            "عدم ورود مدت سپرده",
            "لطفا مدت سپرده خودرا وارد کنید ",
            "warning",
            2000,
          );
          return;
        }
        if (this.isValidTedad == false || this.isValidMablaghVam == false) {
          return;
        }
        if (
          !this.tblMavaredMasrafiVamId > 0 &&
          this.$session.get("CustCode") == 793
        ) {
          this.$mySweetDefault(
            "عدم ورود مورد مصرف وام",
            "لطفا مورد مصرف وام خود را وارد کنید ",
            "warning",
            2000,
          );
          return;
        }
      }
      if (number == 4) {
        if (this.ListNoePolicyFilter.tedad != undefined) {
          if (this.ListZamen.length != this.ListNoePolicyFilter.tedad) {
            this.$mySweetDefaultTost(
              "عدم تکمیل ضامنین",
              "اطلاعات هر " +
                this.ListNoePolicyFilter.tedad +
                " ضامن باید تکمیل شوند",
              "warning",
              1500,
            );
            return;
          }
        }
      }
      if (number == 5) {
        if (!this.hasRequiredAttachment()) {
          this.$mySweetDefaultTost(
            "خطا",
            "بارگذاری مدارک الزامی است",
            "warning",
            2000,
          );
          return;
        }
        if (
          this.$session.get("CustCode") == "932" &&
          this.SelectedVam.id != "11292371"
        ) {
          if (this.codeKasrAghsat != null && this.codeKasrAghsat.length == 13) {
            this.activateStep(number);
            return;
          } else if (
            this.codeKasrAghsat == null ||
            this.codeKasrAghsat.length == 0
          ) {
            this.$mySweetDefault(
              "خطا",
              "کد کسر اقساط خودرا وارد کنید ",
              "error",
              2000,
            );
            return;
          } else {
            this.$mySweetDefault(
              "خطا",
              "کد کسر اقساط باید 13 رقمی باشد",
              "error",
              2000,
            );
            return;
          }
        }
      }
      this.activateStep(number);
    },
    GetNoeVam() {
      var formdata = new FormData();
      formdata.append(
        "wwwtblShobeId",
        this.$session.get("UserInfoNetPa").wwwtblShobeId,
      );
      this.DataAxiosGetNoeVam.ArryfildValue = formdata;

      this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
        this.Vamha = data;
      });
    },
    UpdateZamenPolicy() {
      this.ListNoePolicyFilter = [];
      if (this.ListNoePolicy != null) {
        for (let index = 0; index < this.ListNoePolicy.length; index++) {
          //console.log("*/*/",this.vamDetail.MablaghVam.replace(/,/g, "").replace(/\./g, ""),);
          if (
            Number(
              this.vamDetail.MablaghVam.replace(/,/g, "").replace(/\./g, ""),
            ) >= this.ListNoePolicy[index].mabAz &&
            Number(
              this.vamDetail.MablaghVam.replace(/,/g, "").replace(/\./g, ""),
            ) <= this.ListNoePolicy[index].mabTa
          ) {
            // console.log('*/*/',Number(this.vamDetail.MablaghVam.replace(/,/g, '').replace(/\./g, '')));
            // console.log('*----',this.ListNoePolicy[index]);
            this.ListNoePolicyFilter = [];
            this.ListNoePolicyFilter = this.ListNoePolicy[index];
          }
        }
      }

      // console.log(this.ListNoePolicyFilter);
    },
    seLectVam(item) {
      let error = false;
      (this.ListCodeMeli = []),
        (this.ListZamen = []),
        (this.attachment = null),
        (this.uploadImageName = ""),
        (this.imageSize = 0),
        (this.ListTaahodat = []),
        (this.ListAzaHesab = []),
        (this.ListNoePolicy = null),
        (this.ListNoePolicyFilter = null),
        (this.lines = []),
        (this.linesattachment = []);
      if (
        item.equal != null &&
        item.equal > 0 &&
        item.tblNoeIdEqual != null &&
        item.tblNoeIdEqual != -1 &&
        (item.equalMin == null || item.equalMin == 0) &&
        (item.equalMax == null || item.equalMax == 0)
      ) {
        // برای این نوع وام شرط چند برابری تعریف شده
        // برای 932 تامین اجتماعی
        this.VamChechUpNoeEquals(item)
          .then((result) => {
            item.maxMablagh = result;
            if (item.minMablagh > result) {
              // درحالت فرمولی نباید مبلغ ابتدا بزرگتر از انتها باشد

              error = true;
              this.$mySweetDefault(
                "هشدار",
                "موجودی حساب شما از حداقل مبلغ درخواستی این نوع وام کمتر می باشد",
                "warning",
                3000,
              );
              return;
            }
          })
          .catch((err) => {
            this.$mySweetDefault("هشدار", err.msg, "warning", 3000);
            error = true;
            return;
          });
      }
      if (
        item.equalMin != null &&
        item.equalMin > 0 &&
        item.tblNoeIdEqualListMin != null &&
        item.tblNoeIdEqualListMin != ""
      ) {
        this.VamChechUpNoeEqualsList(item.equalMin, item.tblNoeIdEqualListMin)
          .then((res) => {
            item.minMablagh = res;
            if (res > item.maxMablagh && item.maxMablagh != 0) {
              // درحالت فرمولی نباید مبلغ ابتدا بزرگتر از انتها باشد
              item.minMablagh = item.maxMablagh;
            }
          })
          .catch((err) => {
            this.$mySweetDefault("هشدار", err.msg, "warning", 3000);
            error = true;
            return;
          });
      }
      if (
        item.equalMax != null &&
        item.equalMax > 0 &&
        item.tblNoeIdEqualListMax != null &&
        item.tblNoeIdEqualListMax != ""
      ) {
        this.VamChechUpNoeEqualsList(item.equalMax, item.tblNoeIdEqualListMax)
          .then((res) => {
            item.maxMablagh = res;
            if (item.minMablagh > res) {
              // درحالت فرمولی نباید مبلغ ابتدا بزرگتر از انتها باشد
              item.minMablagh = res;
            }
          })
          .catch((err) => {
            this.$mySweetDefault("هشدار", err.msg, "warning", 3000);
            error = true;
            return;
          });
      }
      if (item.equalHoghogh != null && item.equalHoghogh > 0) {
        this.VamChechUpNoeEqualHoghogh(item.equalHoghogh).then((res) => {
          if (res == 0) {
            item.maxMablagh = 0;
            item.minMablagh = 0;
          } else {
            item.maxMablagh = res;
            if (item.minMablagh > res) {
              // درحالت فرمولی نباید مبلغ ابتدا بزرگتر از انتها باشد
              item.minMablagh = res;
            }
          }
        });
      }

      this.FixInputMabVam = item.isFixInputMablaghVam;

      var formdata = new FormData();
      formdata.append(
        "wwwtblAzaId",
        this.$session.get("UserInfoNetPa").wwwtblAzaId,
      );
      formdata.append("wwwtblNoeId", item.id);
      formdata.append("CustCode", this.$session.get("CustCode"));
      formdata.append("MablaghEftetahHesab", this.$GetMablaghEftetahHesab());

      this.DataActionVamCondition.ArryfildValue = formdata;
      this.$PostFormData(this.DataActionVamCondition)
        .then((res) => {
          switch (res.id) {
            case 0:
              error == false ? (this.SelectedVam = item) : false;

              this.vamDetail.Mablaghghest =
                this.SelectedVam.minTedad > 0 && this.SelectedVam.minMablagh > 0
                  ? this.$Comma3ragham(
                      Math.floor(
                        this.SelectedVam.minMablagh / this.SelectedVam.minTedad,
                      ),
                    )
                  : 0;

              this.vamDetail.MablaghVam =
                this.$session.get("CustCode") == "932"
                  ? // ? this.$Comma3ragham(Math.round(this.SelectedVam.maxMablagh))
                    this.$Comma3ragham(
                      Math.ceil(this.SelectedVam.maxMablagh / 1000) * 1000,
                    )
                  : this.SelectedVam.minMablagh > 0
                  ? this.$Comma3ragham(this.SelectedVam.minMablagh)
                  : "0";
              this.vamDetail.TedadGhest =
                this.$session.get("CustCode") == "932"
                  ? this.SelectedVam.maxTedad
                  : this.SelectedVam.minTedad;
              this.isValidTedad = true;
              this.isValidMablaghVam = true;
              this.lines =
                this.SelectedVam.des != ""
                  ? this.SelectedVam.des.split("\n")
                  : null;
              this.linesattachment =
                this.SelectedVam.desUpload != ""
                  ? this.SelectedVam.desUpload.split("\n")
                  : null;

              var formdata = new FormData();
              formdata.append("id", this.SelectedVam.settingId);
              this.DataAxiosZamenPolicy.ArryfildValue = formdata;
              this.$PostFormData(this.DataAxiosZamenPolicy)
                .then((res) => {
                  var formdata1 = new FormData();
                  formdata1.append(
                    "wwwtblAzaId",
                    this.$session.get("UserInfoNetPa").wwwtblAzaId,
                  );
                  let GetTafsilyType932 = {
                    ArryfildValue: "",
                    Method: "Post",
                    Action: "RequestVamNew/VamChechTafsilyType932",
                    Token: this.$session.get("TokenNetPa"),
                  };
                  GetTafsilyType932.ArryfildValue = formdata1;
                  this.$PostFormData(GetTafsilyType932).then((data) => {
                    if (
                      data == 293441 &&
                      this.$session.get("CustCode") == "932"
                    ) {
                      this.ListNoePolicy = [];
                      // console.log(this.ListNoePolicy);
                    } else {
                      this.ListNoePolicy = res;
                    }
                    this.UpdateZamenPolicy();
                  });
                })
                .finally(() => {});
              break;
            case 1:
              this.$mySweetDefault(
                "هشدار",
                "سابقه عضویت شما جهت درخواست وام کافی نمیباشد.",
                "warning",
                3000,
              );
              break;
            case 2:
              this.$mySweetDefault(
                "هشدار",
                "سقف بودجه ماهیانه به اتمام رسیده است.",
                "warning",
                3000,
              );
              break;
            case 3:
              this.$mySweetDefault(
                "هشدار",
                "موجودی حساب شما جهت درخواست وام کمتر از سقف تایید شده میباشد.",
                "warning",
                3000,
              );
              break;
            case 4:
              this.$mySweetDefault(
                "هشدار",
                "به علت عدم رعایت سقف بدهی قبلی از این نوع وام شما مجاز به ثبت درخواست نمیباشید.",
                "warning",
                3000,
              );
              break;
            case 5:
              this.$mySweetDefault(
                "هشدار",
                "به علت عدم رعایت محدوده روز درخواست مجاز به ثبت درخواست نمیباشید.",
                "warning",
                3000,
              );
              break;
            case 6:
              this.$mySweetDefault(
                "هشدار",
                "این تسهیلات پیش از این توسط شما درخواست داده شده است.",
                "warning",
                2000,
              );
              break;
            case 7:
              this.$mySweetDefault(
                "هشدار",
                "به علت بدهی در دیگر وام ها امکان درخواست نمی باشد",
                "warning",
                2000,
              );
              break;
            case 8:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع واع باید مبلغ افتتاح حساب واریز شده باشد",
                "warning",
                2000,
              );
              break;
            case 9:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این وام باید از افتتاح حساب شما حداقل " +
                  item.minMahAzEftetahHesab +
                  " ماه گذشته باشد",
                "warning",
                2000,
              );
              break;
            case 10:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام تعداد اقساط باقی مانده وام قبلی شما بیشتر از حد تعیین شده می باشد",
                "warning",
                3000,
              );
              break;
            case 11:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام  باید وام های قبلی شما تسویه شده باشد",
                "warning",
                3000,
              );
              break;
            case 12:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام باید حداقل مدتی از زمان تسویه آخرین وام شما گذشته باشد",
                "warning",
                3000,
              );
              break;
            case 13:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام باید حداقل مدتی از تاریخ افتتاح حساب شما گذشته باشد",
                "warning",
                3000,
              );
              break;
            case 14:
              this.$mySweetDefault(
                "هشدار",
                "برای درخواست این نوع وام باید حداقل " +
                  item.minDarsadAzTasvieHaminNoe +
                  " درصد از تاریخ دریافت وام های شما گذشته باشد",
                "warning",
                3000,
              );
              break;
            case 15:
              this.$mySweetDefault(
                "هشدار",
                "به علت داشتن درخواست تسهیلات باز از این نوع وام و یا وام های دیگر امکان درخواست از این نوع وام امکان پذیر نمی باشد",
                "warning",
                3000,
              );
              break;
            default:
              this.$mySweetDefault(
                "خطا",
                "پاسخی از سرور دریافت نشد.",
                "error",
                2000,
              );
              break;
          }
        })
        .finally(() => {});
      //this.SelectedVam=item
    },
    clickUploader() {
      document.getElementById("attachmentUploader").click();
    },
    changeattach(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "zip",
        "rar",
        "pdf",
      ];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }
      if (
        this.$session.get("CustCode") == "8002" ||
        this.$session.get("CustCode") == "932"
      ) {
        this.zip()
          .then((zipfile) => {
            if (!zipfile) {
              this.attachment = null;
              return;
            }
            this.attachment = this.base64;
          })
          .catch(() => {
            this.cancelUpload();
          });
      } else {
        this.attachment =
          document.getElementById("attachmentUploader").files[0];
        this.uploadImageName = this.attachment.name;
        this.imageSize = Math.round(this.attachment.size / 1000);
        if (this.attachment.size / 1000000 > 5) {
          this.$mySweetDefaultTost(
            "هشدار",
            "حجم فایل نمیتواند بیش از 5 مگابایت باشد",
            "error",
            3000,
          );
          document.getElementById("attachmentUploader").value = null;
          this.attachment = null;
          this.uploadImageName = "";
          this.imageSize = 0;
        }
      }
    },
    VamChechUpNoeEquals(item) {
      return new Promise((success, error) => {
        var formdata = new FormData();
        formdata.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formdata.append("Equal", item.equal + "");
        formdata.append("wwwtblNoeIdEqual", item.tblNoeIdEqual);
        let DataAxiosChechUp = {
          ArryfildValue: "",
          Method: "Post",
          Action: "RequestVamNew/VamChechUpNoeEquals",
          Token: this.$session.get("TokenNetPa"),
        };
        DataAxiosChechUp.ArryfildValue = formdata;
        this.$PostFormData(DataAxiosChechUp).then((res) => {
          if (res.status == "faild") {
            error(res);
          }
          success(res);
        });
      });
    },
    VamChechUpNoeEqualsList(Eq, ListE) {
      return new Promise((success, error) => {
        var formdata = new FormData();
        formdata.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formdata.append("Equal", Eq);
        formdata.append("wwwtblNoeIdEqualList", ListE);
        let DataAxiosChechUp = {
          ArryfildValue: "",
          Method: "Post",
          Action: "RequestVamNew/VamChechUpNoeEqualsList",
          Token: this.$session.get("TokenNetPa"),
        };
        DataAxiosChechUp.ArryfildValue = formdata;
        this.$PostFormData(DataAxiosChechUp).then((res) => {
          if (res.status == "faild") {
            error(res);
          }
          success(res);
        });
      });
    },
    VamChechUpNoeEqualHoghogh(EqHoghogh) {
      return new Promise((success, error) => {
        var formdata = new FormData();
        formdata.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formdata.append("EqualHoghogh", EqHoghogh);
        let DataAxiosChechUp = {
          ArryfildValue: "",
          Method: "Post",
          Action: "RequestVamNew/VamChechUpNoeEqualHoghogh",
          Token: this.$session.get("TokenNetPa"),
        };
        DataAxiosChechUp.ArryfildValue = formdata;
        this.$PostFormData(DataAxiosChechUp).then((res) => {
          success(res);
        });
      });
    },
    changefile(e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "zip",
        "rar",
        "pdf",
      ];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }
      if (document.getElementById("Uploader").files[0].size > 1024 * 1024 * 1) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "  حجم فایل مورد نظر بیشتر از 1 مگابایت است ",
          "error",
          3000,
        );
        return;
      }
      this.fileinfo = document.getElementById("Uploader").files[0];
    },
    clickUploaderZamen() {
      document.getElementById("Uploader").click();
    },
    NewZamen() {
      if (!this.$ValidForm("NewZamenForm")) {
        return;
      }
      if (this.ZamenToInsert.NameFamily.trim() == "") {
        this.$mySweetDefaultTost(
          "خطا",
          "نام و نام خانوادگی الزامی می باشد",
          "error",
          2000,
        );
        this.ZamenToInsert = {};
        return;
      }
      if (this.ZamenToInsert.PerNo == "" || this.ZamenToInsert.PerNo == null) {
        this.$mySweetDefaultTost(
          "خطا",
          "کد پرسنلی الزامی می باشد ",
          "error",
          2000,
        );
        this.ZamenToInsert = {};
        return;
      }
      if (
        this.ZamenToInsert.Mobile == "" ||
        this.ZamenToInsert.Mobile == null ||
        this.ZamenToInsert.Mobile.length < 11
      ) {
        this.$mySweetDefaultTost(
          "خطا",
          "شماره موبایل به  درستی وارد نشده",
          "error",
          2000,
        );
        this.ZamenToInsert = {};
        return;
      }
      if (
        this.$session.get("CustCode") == "932" ||
        this.$session.get("CustCode") == "8002"
      ) {
        this.ZamenToInsert["Tel"] = "";
        this.ZamenToInsert["Pedar"] = "";
        this.ZamenToInsert["Adres"] = "";
        this.ZamenToInsert["file"] = this.fileinfo;
      }

      this.ListZamenToInsert.push(this.ZamenToInsert);
      this.ListZamen.push(this.ZamenToInsert);

      this.ZamenToInsert = {};
      this.fileinfo = {};
      var genericModalEl = document.getElementById("BtnCloseModal");
      genericModalEl.click();
    },
    // async zip(listFile) {
    //   listFile.forEach(element => {
    //     if ((element.size / 1000000 > 5)){
    //       this.$mySweetDefaultTost('هشدار', 'حجم یکی از فایل ها بیشتر از 5 مگابایت میباشد', 'error', 3000)
    //       return;
    //     }
    //   });
    //   let filedata
    //   let base64
    //   let isImage
    //   let fileFormat
    //   let zip = new JSZip()
    //   console.log(document.getElementById('attachmentUploader').files);
    //   listFile.forEach(element => {
    //     console.log(element);
    //     zip.file(element.name, element)
    //   });
    //   await zip
    //     .generateAsync({ type: 'base64' })
    //     .then(function (Convertbase64) {
    //       filedata = 'data:application/zip;base64,' + Convertbase64
    //     })
    //     .finally(() => {
    //       base64 = filedata
    //       base64 = base64.split(',')[1]
    //       isImage = false
    //       fileFormat = 'zip'
    //     })
    //   // this.File = 'data:application/zip;base64,' + base64
    //   this.FileZip = base64
    //   return base64
    // }
    async zip() {
      var input = document.getElementById("attachmentUploader");

      let filedata = null;
      let zip = new JSZip();
      this.imageSize = 0;
      this.uploadImageName = "";
      for (let index = 0; index < input.files.length; index++) {
        let lengthSplit = input.files[index].name.split(".").length;
        var Checktypes =
          "." +
          input.files[index].name.split(".")[lengthSplit - 1].toLowerCase();
        this.imageSize += input.files[index].size;
        this.uploadImageName += input.files[index].name + " , ";
        const element = input.files[index];
        let filename = input.files[index].name;
        var folderName = this.$store.state.JalaliDate;
        folderName = folderName.replaceAll("/", "_");
        zip.file(folderName + "/" + filename, element);
      }
      this.imageSize = Math.round(this.imageSize / 1000);
      if (this.imageSize < 10010) {
        await zip
          .generateAsync({ type: "base64" })
          .then(function (Convertbase64) {
            filedata = "data:application/zip;base64," + Convertbase64;
          })
          .finally(() => {
            this.base64 = filedata;
            this.base64 = this.base64.split(",")[1];
            this.fileFormat = "zip";
          });
        return this.base64;
      } else {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          "مجموع حجم فایل ها باید کمتر از 10 مگابایت باشد",
          "info",
          3000,
        );
        this.cancelUpload();
        return null;
      }
    },
    cancelUpload() {
      this.base64 = null;
      this.attachment = null;
      this.uploadImageName = "";
      this.imageSize = 0;
      this.fileFormat = "";
      this.isImage = null;
      var input = document.getElementById("attachmentUploader");
      if (input) input.value = "";
    },
    GetMavaredMasrafi() {
      var formdata = new FormData();
      var DataAxiosSubmit = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "InsNewVam/GetMavaredMasrafVam",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostFormData(DataAxiosSubmit).then((res) => {
        if (res.state == true) {
          this.ListMavaredMasrafVam = res.data;
          this.tblMavaredMasrafiVamId = res.data[0].id;
        } else {
          this.ListMavaredMasrafVam = [];
        }
      });
    },
  },
};
</script>
<style scoped>
.request-vam-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.request-vam-step-panel {
  flex: 1 1 100%;
  align-self: stretch;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.request-vam-step {
  padding: 0.75rem 0;
}

.request-vam-form-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.5rem 0.75rem;
  width: 100%;
  margin: 0;
  padding: 0;
}

.request-vam-form-grid > [class*="col-"] {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  flex: none;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (min-width: 768px) {
  .request-vam-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .request-vam-form-grid > .col-md-6 {
    flex: none;
    max-width: 100%;
    width: 100%;
  }
}

.request-vam-date-field ::v-deep .vpd-main {
  display: block;
  width: 100%;
}

.request-vam-date-field ::v-deep .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  height: calc(1.5em + 0.75rem + 2px);
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background: #fff;
  overflow: hidden;
}

.request-vam-date-field ::v-deep .vpd-input-group input,
.request-vam-date-field ::v-deep .vpd-input-group input.form-control {
  flex: 1 1 auto;
  min-width: 0;
  height: calc(1.5em + 0.75rem + 2px);
  min-height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  padding: 0.375rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent;
  font-size: 1rem;
  line-height: 1.5;
}

.request-vam-date-field ::v-deep .vpd-input-group .vpd-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  margin: 0;
  padding: 0;
  border: none;
  border-right: 1px solid #ced4da;
  border-radius: 0;
  background: #f8f9fa;
}

/* ---------- Step 3: guarantors ---------- */
.request-vam-zamen-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.15rem 1.5rem;
  width: 100%;
}

@media (min-width: 576px) {
  .request-vam-zamen-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 1.25rem;
  }

  .request-vam-zamen-slot--solo {
    grid-column: 1 / -1;
  }
}

.request-vam-zamen-slot {
  min-width: 0;
  width: 100%;
}

.request-vam-zamen-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 10px;
  background: #fff;
  direction: rtl;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.request-vam-zamen-input-group:hover {
  border-color: #bdcbd4;
}

.request-vam-zamen-input-group:focus-within {
  border-color: #05b8c8;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.request-vam-zamen-code {
  flex: 1 1 auto;
  min-width: 0;
  height: 100% !important;
  padding: 0 0.8rem !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 13px;
  text-align: left;
  direction: ltr;
}

.request-vam-zamen-code::placeholder {
  color: #9aa8b5;
  text-align: right;
  direction: rtl;
}

.request-vam-zamen-code:focus {
  box-shadow: none !important;
}

.request-vam-zamen-check-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 4.5rem;
  padding: 0 1rem;
  border: none;
  border-right: 1px solid #dbe5eb;
  border-radius: 0;
  background: #edf7fb;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease;
}

.request-vam-zamen-check-btn:hover {
  background: #dcf0f6;
}

.request-vam-zamen-check-btn:focus {
  outline: none;
}

.request-vam-zamen-check-btn:focus-visible {
  background: #dcf0f6;
  box-shadow: inset 0 0 0 2px #05b8c8;
}

.request-vam-zamen-ramz {
  margin-top: 0.85rem;
}

.request-vam-zamen-result {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  margin-top: 0.6rem;
  padding: 0.4rem 0.5rem 0.4rem 0.75rem;
  border: 1px solid rgba(40, 167, 69, 0.25);
  border-radius: 10px;
  background: #f6fcf8;
  font-size: 13px;
  text-align: right;
}

.request-vam-zamen-result > i {
  flex-shrink: 0;
  color: #28a745;
  font-size: 13px;
}

.request-vam-zamen-result__label {
  flex-shrink: 0;
  color: #6b7b8e;
}

.request-vam-zamen-result__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #29345f;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-vam-zamen-result__remove {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #8091a3;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease;
}

.request-vam-zamen-result__remove:hover {
  background: #fcefed;
  color: #b44f46;
}

.request-vam-zamen-result__remove:focus {
  outline: none;
}

.request-vam-zamen-result__remove:focus-visible {
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.3);
}

/* shared small pieces (steps 3 & 4) */
.vam-hint {
  display: block;
  margin-top: 0.4rem;
  font-size: 12px;
  line-height: 1.7;
  color: #b44f46;
}

.vam-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 0.85rem 1.1rem;
  border: 1px solid #eef2f5;
  border-right: 3px solid #287db4;
  border-radius: 14px;
  background: #f9fbfc;
  color: #3b4a5c;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.9;
  text-align: right;
}

.vam-notice > i {
  flex-shrink: 0;
  margin-top: 0.35rem;
  font-size: 13px;
  color: #287db4;
}

.vam-notice--warning {
  border-right-color: #c48726;
}

.vam-notice--warning > i {
  color: #c48726;
}

.vam-notice__link {
  padding: 0 2px;
  color: #287db4;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* ---------- Step 4: upload ---------- */
.request-vam-upload-section > * + * {
  margin-top: 1rem;
}

.request-vam-upload-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  width: 100%;
  padding: 1.75rem 1rem 1.5rem;
  border: 1.5px dashed #bdcbd4;
  border-radius: 14px;
  background: #f9fbfc;
  text-align: center;
}

.request-vam-upload-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-bottom: 0.35rem;
  border-radius: 14px;
  background: #edf7fb;
  color: #287db4;
  font-size: 20px;
  line-height: 1;
}

.request-vam-upload-card__title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #29345f;
}

.request-vam-upload-card__hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  color: #6b7b8e;
}

.request-vam-upload-card__meta {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 100%;
  margin-top: 0.6rem;
  padding: 0.45rem 0.8rem;
  border: 1px solid #e8eef2;
  border-radius: 10px;
  background: #fff;
  font-size: 13px;
  text-align: right;
}

.request-vam-upload-card__meta > i {
  flex-shrink: 0;
  color: #287db4;
}

.request-vam-upload-card__file {
  min-width: 0;
  overflow: hidden;
  color: #13243a;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-vam-upload-card__size {
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7b8e;
}

.request-vam-upload-card__btn {
  min-height: 40px;
  margin-top: 0.6rem;
  padding: 0 1.4rem;
  border: 1px solid #29345f;
  border-radius: 12px;
  background: #fff;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.18s ease;
}

.request-vam-upload-card__btn:hover {
  background: #f1f3f9;
}

.request-vam-upload-card__btn:focus {
  outline: none;
}

.request-vam-upload-card__btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

/* ---------- Step 5: final review ---------- */
.request-vam-review > * + * {
  margin-top: 1rem;
}

.request-vam-review-intro {
  margin: 0;
  font-size: 13px;
  line-height: 1.9;
  color: #6b7b8e;
  text-align: right;
}

/* hero summary */
.request-vam-review-hero {
  padding: 1.1rem 1.25rem 1.15rem;
  border-radius: 18px;
  color: #fff;
  text-align: center;
  background: radial-gradient(
      circle at 15% 20%,
      rgba(5, 184, 200, 0.24),
      transparent 32%
    ),
    radial-gradient(
      circle at 90% 80%,
      rgba(141, 88, 164, 0.28),
      transparent 38%
    ),
    linear-gradient(155deg, #4a4584 0%, #29345f 62%, #20254c 100%);
  box-shadow: 0 12px 24px rgba(41, 52, 95, 0.18);
}

.request-vam-review-hero__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.request-vam-review-hero__name {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  color: rgba(232, 242, 248, 0.88);
  text-align: right;
}

.request-vam-review-hero__name i {
  flex-shrink: 0;
  color: #3cb9dd;
}

.request-vam-review-hero__edit,
.request-vam-review-panel__edit {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
  padding: 0.3rem 0.7rem;
  border: 0;
  border-radius: 999px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s ease;
}

.request-vam-review-hero__edit i,
.request-vam-review-panel__edit i {
  font-size: 10px;
}

.request-vam-review-hero__edit {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

.request-vam-review-hero__edit:hover {
  background: rgba(255, 255, 255, 0.24);
}

.request-vam-review-hero__amount {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.9rem;
  direction: ltr;
}

.request-vam-review-hero__amount span {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: 0.2px;
}

.request-vam-review-hero__amount small {
  font-size: 13px;
  font-weight: 500;
  color: rgba(232, 242, 248, 0.76);
}

.request-vam-review-hero__caption {
  display: block;
  font-size: 12px;
  color: rgba(232, 242, 248, 0.76);
}

.request-vam-review-hero__stats {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding-top: 0.9rem;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
}

.request-vam-review-hero__stat {
  flex: 1 1 0;
  min-width: 120px;
  padding: 0.25rem 0.5rem;
}

.request-vam-review-hero__stat + .request-vam-review-hero__stat {
  border-right: 1px solid rgba(255, 255, 255, 0.14);
}

.request-vam-review-hero__stat-label {
  display: block;
  font-size: 12px;
  color: rgba(232, 242, 248, 0.7);
}

.request-vam-review-hero__stat-value {
  display: block;
  margin-top: 2px;
  font-size: 14px;
  font-weight: 700;
  unicode-bidi: isolate;
}

/* panels */
/* flat sections: hairline separators instead of boxes */
.request-vam-review-panel {
  padding: 1.1rem 0 0;
  border: 0;
  border-top: 1px solid #e8eef2;
  border-radius: 0;
  background: transparent;
}

.request-vam-review-panel__header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.85rem;
}

.request-vam-review-panel__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 9px;
  background: #edf7fb;
  color: #287db4;
  font-size: 13px;
}

.request-vam-review-panel__title {
  flex: 1 1 auto;
  margin: 0;
  font-size: 14px;
  font-weight: 800;
  color: #29345f;
  text-align: right;
}

.request-vam-review-panel__edit {
  background: #f4f7f9;
  color: #29345f;
}

.request-vam-review-panel__edit:hover {
  background: #e9eff2;
}

.request-vam-review-hero__edit:focus,
.request-vam-review-panel__edit:focus {
  outline: none;
}

.request-vam-review-hero__edit:focus-visible,
.request-vam-review-panel__edit:focus-visible {
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.35);
}

.request-vam-review-empty {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 0.9rem;
  border-radius: 10px;
  background: #f9fbfc;
  color: #6b7b8e;
  font-size: 13px;
  text-align: right;
}

.request-vam-review-empty--danger {
  background: #fcefed;
  color: #b44f46;
  font-weight: 600;
}

/* guarantors */
.request-vam-review-guarantor-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.request-vam-review-guarantor-card {
  overflow: hidden;
  border: 0;
  border-radius: 12px;
  background: #f9fbfc;
}

.request-vam-review-guarantor-card__header {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0.9rem 0.35rem;
  background: transparent;
  text-align: right;
}

.request-vam-review-guarantor-card__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(145deg, #05b8c8, #8d58a4);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.request-vam-review-guarantor-card__title {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: #29345f;
  word-break: break-word;
}

.request-vam-review-guarantor-card__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0 1.5rem;
  padding: 0.25rem 0.9rem 0.4rem;
}

@media (min-width: 576px) {
  .request-vam-review-guarantor-card__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .request-vam-review-field--full {
    grid-column: 1 / -1;
  }
}

.request-vam-review-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
  width: 100%;
  padding: 0.5rem 0;
  border-bottom: 1px solid #eaf0f3;
  direction: rtl;
  text-align: right;
}

.request-vam-review-field--full {
  align-items: flex-start;
  border-bottom: none;
}

.request-vam-review-field__label {
  flex: 0 0 auto;
  font-size: 12.5px;
  color: #6b7b8e;
  line-height: 1.6;
  white-space: nowrap;
}

.request-vam-review-field__value {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #13243a;
  line-height: 1.6;
  text-align: left;
  word-break: break-word;
}

.request-vam-review-field--full .request-vam-review-field__value {
  text-align: right;
}

.request-vam-review-field__value--ltr {
  direction: ltr;
  unicode-bidi: isolate;
  text-align: left;
}

/* attachment */
.request-vam-review-file {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 0.9rem;
  border: 0;
  border-radius: 10px;
  background: #f9fbfc;
  font-size: 13px;
  text-align: right;
}

.request-vam-review-file > i {
  flex-shrink: 0;
  color: #287db4;
}

.request-vam-review-file__name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  color: #13243a;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.request-vam-review-file__size {
  flex-shrink: 0;
  font-size: 12px;
  color: #6b7b8e;
}

/* terms checkbox (customer 932) */
.request-vam-review-terms {
  align-items: flex-start;
}

.request-vam-review-terms label {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.9;
  color: #3b4a5c !important;
  cursor: pointer;
}

.request-vam-review-terms input[type="checkbox"] {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-top: 0.4rem;
  accent-color: #c48726;
  cursor: pointer;
}

@media (max-width: 575px) {
  .request-vam-review-hero__amount span {
    font-size: 26px;
  }

  .request-vam-review-hero__stat {
    flex: 1 1 100%;
    padding: 0.4rem 0;
  }

  .request-vam-review-hero__stat + .request-vam-review-hero__stat {
    border-right: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}

/* ---------- Step navigation buttons (NetPa design system) ---------- */
.request-vam-step-nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  margin-top: 1.75rem;
  padding-top: 1.25rem;
  border-top: 1px solid #e8eef2;
  direction: rtl;
}

/* align with the centered 680px content column of steps 1–5 */
.request-vam-step-nav--narrow {
  width: min(calc(100% - 1rem), calc(680px - 1rem));
  margin-right: auto;
  margin-left: auto;
}

.request-vam-step-nav--next-only {
  justify-content: flex-end;
}

.request-vam-step-nav__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 8.5rem;
  min-height: 46px;
  padding: 0 1.5rem;
  border: 1px solid transparent;
  border-radius: 14px;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.25;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease, border-color 0.18s ease, opacity 0.18s ease;
}

.request-vam-step-nav__btn i {
  font-size: 12px;
}

.request-vam-step-nav__btn:focus {
  outline: none;
}

.request-vam-step-nav__btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.request-vam-step-nav__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* secondary */
.request-vam-step-nav__btn--prev {
  color: #29345f;
  background: #fff;
  border-color: #dbe5eb;
}

.request-vam-step-nav__btn--prev:hover:not(:disabled) {
  background: #f4f7f9;
  border-color: #bdcbd4;
}

/* primary */
.request-vam-step-nav__btn--next,
.request-vam-step-nav__btn--submit {
  color: #fff;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.22);
}

.request-vam-step-nav__btn--next:hover:not(:disabled),
.request-vam-step-nav__btn--submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 12px 24px rgba(41, 52, 95, 0.26);
}

.request-vam-step-nav__btn--next:active:not(:disabled),
.request-vam-step-nav__btn--submit:active:not(:disabled) {
  transform: translateY(0);
}

.request-vam-step-nav__btn--next:focus-visible,
.request-vam-step-nav__btn--submit:focus-visible {
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.22), 0 0 0 4px rgba(5, 184, 200, 0.3);
}

@media (max-width: 575px) {
  .request-vam-step-nav {
    flex-wrap: nowrap;
  }

  .request-vam-step-nav__btn {
    flex: 1 1 0;
    min-width: 0;
    padding: 0 0.75rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .request-vam-step-nav__btn {
    transition: none;
  }

  .request-vam-step-nav__btn:hover {
    transform: none !important;
  }
}

/* ---------- Step 1: loan type picker ---------- */
.request-vam-type-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 0.5rem 0.5rem 0;
  box-sizing: border-box;
}

.request-vam-type-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin: 0;
  padding: 1rem 1.15rem;
  border: 1px solid #dbe5eb;
  border-radius: 14px;
  background: #fff;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  text-align: right;
  cursor: pointer;
  appearance: none;
  transition: border-color 0.18s ease, background-color 0.18s ease,
    box-shadow 0.18s ease;
}

.request-vam-type-card:hover {
  border-color: #bdcbd4;
  background: #fbfdfd;
}

.request-vam-type-card:focus {
  outline: none;
}

.request-vam-type-card:focus-visible {
  border-color: #05b8c8;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

.request-vam-type-card--selected,
.request-vam-type-card--selected:hover {
  border-color: rgba(40, 167, 69, 0.45);
  background: #f6fcf8;
  box-shadow: inset -3px 0 0 #28a745;
  cursor: default;
}

.request-vam-type-card__radio {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  border: 1.5px solid #cfd8de;
  border-radius: 50%;
  background: #fff;
  color: transparent;
  font-size: 10px;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease;
}

.request-vam-type-card:hover .request-vam-type-card__radio {
  border-color: #28a745;
}

.request-vam-type-card--selected .request-vam-type-card__radio {
  border-color: #28a745;
  background: #28a745;
  color: #fff;
}

.request-vam-type-card__info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
}

.request-vam-type-card__title {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  color: #29345f;
}

.request-vam-type-card__desc {
  font-size: 12.5px;
  line-height: 1.8;
  color: #6b7b8e;
}

/* ---------- Step 2: minimal form (NetPa design system tokens) ---------- */
.vam-section {
  --bnp-brand-navy: #29345f;
  --bnp-brand-cyan: #05b8c8;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-border-hover: #bdcbd4;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);

  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 0.5rem 0.5rem 0;
  box-sizing: border-box;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

/* grid: 1 col on mobile, 2 cols from tablet up — plenty of air */
.vam-section .request-vam-form-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem 1.5rem;
  width: 100%;
  margin: 0;
}

.vam-section .request-vam-form-grid > [class*="col-"] {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  flex: none;
  padding: 0 !important;
}

@media (min-width: 576px) {
  .vam-section .request-vam-form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    row-gap: 1.25rem;
  }
}

/* reading order: amount · date / count · installment / payment · account */
.vam-f-amount {
  order: 1;
}
.vam-f-date {
  order: 2;
}
.vam-f-count {
  order: 3;
}
.vam-f-installment {
  order: 4;
}
.vam-f-pay {
  order: 5;
}
.vam-f-account {
  order: 6;
}
.vam-f-extra {
  order: 7;
}

.vam-section label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  color: var(--bnp-text-secondary) !important;
}

.vam-section .form-control {
  height: 40px;
  padding: 0 0.8rem;
  border: 1px solid var(--bnp-border-default);
  border-radius: 10px;
  background-color: #fff;
  color: var(--bnp-text-primary);
  font-family: inherit;
  font-size: 13px;
  box-shadow: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    background-color 0.18s ease;
}

.vam-section .form-control:hover:not(:disabled) {
  border-color: var(--bnp-border-hover);
}

.vam-section .form-control:focus {
  border-color: var(--bnp-brand-cyan);
  box-shadow: var(--bnp-focus-ring);
}

.vam-section .form-control:disabled,
.vam-section .form-control[disabled] {
  background-color: #f6f8fa;
  border-color: var(--bnp-border-subtle);
  color: var(--bnp-brand-navy);
  font-weight: 600;
  opacity: 0.85;
  cursor: not-allowed;
}

.vam-section select.form-control {
  padding: 0 0.6rem;
}

.vam-section .btn.btn-primary {
  min-height: 34px;
  margin-top: 0.5rem;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  font-family: inherit;
  font-size: 12px;
  font-weight: 700;
}

.request-vam-date-field ::v-deep .vpd-input-group {
  height: 40px;
  min-height: 40px;
  border-color: #e8eef2;
  border-radius: 10px;
  background: #f6f8fa;
}

.request-vam-date-field ::v-deep .vpd-input-group input,
.request-vam-date-field ::v-deep .vpd-input-group input.form-control {
  height: 38px;
  min-height: 38px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #29345f;
}

.request-vam-date-field ::v-deep .vpd-input-group .vpd-icon-btn {
  border-right-color: #e8eef2;
  background: #eff3f6;
}

/* ----- info panels: quiet, neutral ----- */
.request-vam-info-cards {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1rem;
  width: 100%;
  max-width: 680px;
  margin: 1.75rem auto 0;
}

.request-vam-info-card {
  width: 100%;
  min-width: 0;
  height: 100%;
  text-align: right;
}

.vam-info {
  padding: 1rem 1.25rem;
  border: 1px solid #eef2f5;
  border-right: 3px solid #c48726;
  border-radius: 14px;
  background: #f9fbfc;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.vam-info--notes {
  border-right-color: #287db4;
}

.vam-info__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 13px;
  font-weight: 700;
  color: #6b7b8e;
}

.vam-info__header i {
  font-size: 13px;
  color: #c48726;
}

.vam-info--notes .vam-info__header i {
  color: #287db4;
}

.vam-info__rows {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0 2rem;
  margin: 0;
  padding: 0;
  list-style: none;
}

.vam-info__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-width: 0;
  padding: 0.55rem 0;
  border-bottom: 1px solid #eaf0f3;
}

.vam-info__label {
  font-size: 13px;
  line-height: 1.5;
  color: #6b7b8e;
}

.vam-info__value {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 700;
  color: #29345f;
  direction: ltr;
  unicode-bidi: isolate;
}

.vam-info__value small {
  margin-right: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #8091a3;
}

.vam-info__text {
  margin: 0 0 0.4rem;
  font-size: 13px;
  line-height: 1.9;
  color: #3b4a5c;
}

.vam-info__text:last-child {
  margin-bottom: 0;
}

.vam-info__list {
  margin: 0;
  padding: 0 1.1rem 0 0;
  font-size: 13px;
  line-height: 1.9;
  color: #3b4a5c;
  list-style: disc;
}

.request-vam-info-card__block + .request-vam-info-card__block {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #eaf0f3;
}

.request-vam-info-card__subtitle {
  margin-bottom: 0.35rem;
  font-size: 13px;
  font-weight: 700;
  color: #29345f;
}
</style>
<style>
.request-vam-content,
.request-vam-step-panel,
.request-vam-type-list,
.request-vam-type-card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

/* ---------- Minimal stepper ---------- */
.vam-stepper {
  width: 100%;
  padding: 0.35rem 0.25rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  box-sizing: border-box;
}

.vam-stepper__list {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.vam-stepper__item {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
}

.vam-stepper__item:not(.vam-stepper__item--last) {
  flex: 1 1 auto;
}

/* connector line toward the next step */
.vam-stepper__item:not(.vam-stepper__item--last)::after {
  content: "";
  flex: 1 1 auto;
  min-width: 16px;
  height: 2px;
  margin: 0 0.6rem;
  border-radius: 2px;
  background: #e3e8ef;
  transition: background 0.25s ease;
}

.vam-stepper__item--completed:not(.vam-stepper__item--last)::after {
  background: #28a745;
}

.vam-stepper__btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.2rem 0.1rem;
  border: none;
  background: transparent;
  color: #6c757d;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.vam-stepper__btn:focus {
  outline: none;
}

.vam-stepper__btn:focus-visible .vam-stepper__circle {
  outline: 2px solid rgba(42, 63, 84, 0.35);
  outline-offset: 2px;
}

.vam-stepper__circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid #cfd6df;
  background: #fff;
  color: #6c757d;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.vam-stepper__circle .fa-check {
  font-size: 10px;
}

.vam-stepper__label {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: #6c757d;
  transition: color 0.2s ease;
}

/* Completed */
.vam-stepper__item--completed .vam-stepper__circle {
  background: #28a745;
  border-color: #28a745;
  color: #fff;
}

.vam-stepper__item--completed .vam-stepper__label {
  color: #2a3f54;
}

/* Active */
.vam-stepper__item--active .vam-stepper__circle {
  background: #28a745;
  border-color: #28a745;
  color: #fff;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.18);
}

.vam-stepper__item--active .vam-stepper__label {
  color: #2a3f54;
  font-weight: 700;
}

/* Hover (clickable only) */
.vam-stepper__btn:not(:disabled):hover .vam-stepper__circle {
  border-color: #28a745;
}

.vam-stepper__btn:not(:disabled):hover .vam-stepper__label {
  color: #2a3f54;
}

/* Locked */
.vam-stepper__btn:disabled {
  cursor: not-allowed;
}

.vam-stepper__item--locked:not(.vam-stepper__item--active):not(.vam-stepper__item--completed) .vam-stepper__circle {
  background: #f0f2f5;
  border-color: #e3e8ef;
  color: #aab3bf;
}

.vam-stepper__item--locked:not(.vam-stepper__item--active):not(.vam-stepper__item--completed) .vam-stepper__label {
  color: #aab3bf;
  font-weight: 500;
}

@media (max-width: 767px) {
  /* show the label only for the current step */
  .vam-stepper__item:not(.vam-stepper__item--active) .vam-stepper__label {
    display: none;
  }

  .vam-stepper__item:not(.vam-stepper__item--last)::after {
    min-width: 8px;
    margin: 0 0.35rem;
  }
}
</style>
